import { jsx as s, jsxs as D, Fragment as st } from "react/jsx-runtime";
import { useState as V, useCallback as R, useRef as W, createContext as Gt, useContext as Yt, useLayoutEffect as qt, useEffect as N, useMemo as ot, memo as j, forwardRef as Me } from "react";
import { create as ro, useStore as oo } from "zustand";
import { createPortal as Jn } from "react-dom";
const er = ["shift", "alt", "meta", "mod", "ctrl", "control"], io = {
  esc: "escape",
  return: "enter",
  left: "arrowleft",
  right: "arrowright",
  up: "arrowup",
  down: "arrowdown",
  ShiftLeft: "shift",
  ShiftRight: "shift",
  AltLeft: "alt",
  AltRight: "alt",
  MetaLeft: "meta",
  MetaRight: "meta",
  OSLeft: "meta",
  OSRight: "meta",
  ControlLeft: "ctrl",
  ControlRight: "ctrl"
};
function Te(e) {
  return (io[e.trim()] || e.trim()).toLowerCase().replace(/key|digit|numpad/, "");
}
function tr(e) {
  return er.includes(e);
}
function Tt(e, t = ",") {
  return e.toLowerCase().split(t);
}
function Mt(e, t = "+", n = ">", r = !1, o, i) {
  let c = [], d = !1;
  e = e.trim(), e.includes(n) ? (d = !0, c = e.toLocaleLowerCase().split(n).map((f) => Te(f))) : c = e.toLocaleLowerCase().split(t).map((f) => Te(f));
  const u = {
    alt: c.includes("alt"),
    ctrl: c.includes("ctrl") || c.includes("control"),
    shift: c.includes("shift"),
    meta: c.includes("meta"),
    mod: c.includes("mod"),
    useKey: r
  }, l = c.filter((f) => !er.includes(f));
  return {
    ...u,
    keys: l,
    description: o,
    isSequence: d,
    hotkey: e,
    metadata: i
  };
}
typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.code !== void 0 && nr([Te(e.code)]);
}), document.addEventListener("keyup", (e) => {
  e.code !== void 0 && rr([Te(e.code)]);
})), typeof window < "u" && (window.addEventListener("blur", () => {
  ge.clear();
}), window.addEventListener("contextmenu", () => {
  setTimeout(() => {
    ge.clear();
  }, 0);
}));
const ge = /* @__PURE__ */ new Set();
function Qt(e) {
  return Array.isArray(e);
}
function ao(e, t = ",") {
  return (Qt(e) ? e : e.split(t)).every((n) => ge.has(n.trim().toLowerCase()));
}
function nr(e) {
  const t = Array.isArray(e) ? e : [e];
  ge.has("meta") && ge.forEach((n) => {
    tr(n) || ge.delete(n.toLowerCase());
  }), t.forEach((n) => {
    ge.add(n.toLowerCase());
  });
}
function rr(e) {
  const t = Array.isArray(e) ? e : [e];
  e === "meta" ? ge.clear() : t.forEach((n) => {
    ge.delete(n.toLowerCase());
  });
}
function co(e, t, n) {
  (typeof n == "function" && n(e, t) || n === !0) && e.preventDefault();
}
function lo(e, t, n) {
  return typeof n == "function" ? n(e, t) : n === !0 || n === void 0;
}
const so = [
  "input",
  "textarea",
  "select",
  "searchbox",
  "slider",
  "spinbutton",
  "menuitem",
  "menuitemcheckbox",
  "menuitemradio",
  "option",
  "radio",
  "textbox"
];
function uo(e) {
  return or(e, so);
}
function or(e, t = !1) {
  const { target: n, composed: r } = e;
  let o, i;
  return fo(n) && r ? (o = e.composedPath()[0] && e.composedPath()[0].tagName, i = e.composedPath()[0] && e.composedPath()[0].role) : (o = n && n.tagName, i = n && n.role), Qt(t) ? !!(o && t && t.some((c) => c.toLowerCase() === o.toLowerCase() || c === i)) : !!(o && t && t);
}
function fo(e) {
  return !!e.tagName && !e.tagName.startsWith("-") && e.tagName.includes("-");
}
function po(e, t) {
  return e.length === 0 && t ? !1 : t ? e.some((n) => t.includes(n)) || e.includes("*") : !0;
}
const mo = (e, t, n = !1) => {
  const { alt: r, meta: o, mod: i, shift: c, ctrl: d, keys: u, useKey: l } = t, { code: f, key: a, ctrlKey: h, metaKey: p, shiftKey: m, altKey: y } = e, b = Te(f);
  if (l && (u == null ? void 0 : u.length) === 1 && u.includes(a.toLowerCase()))
    return !0;
  if (!(u != null && u.includes(b)) && !["ctrl", "control", "unknown", "meta", "alt", "shift", "os"].includes(b))
    return !1;
  if (!n) {
    if (r !== y && b !== "alt" || c !== m && b !== "shift")
      return !1;
    if (i) {
      if (!p && !h)
        return !1;
    } else if (o !== p && b !== "meta" && b !== "os" || d !== h && b !== "ctrl" && b !== "control")
      return !1;
  }
  return u && u.length === 1 && u.includes(b) ? !0 : u && u.length > 0 ? u.includes(b) ? ao(u) : !1 : !u || u.length === 0;
}, ir = Gt(void 0), ho = () => Yt(ir);
function go({ addHotkey: e, removeHotkey: t, children: n }) {
  return /* @__PURE__ */ s(ir.Provider, { value: { addHotkey: e, removeHotkey: t }, children: n });
}
function Ut(e, t) {
  return e && t && typeof e == "object" && typeof t == "object" ? Object.keys(e).length === Object.keys(t).length && // @ts-expect-error TS7053
  Object.keys(e).reduce((n, r) => n && Ut(e[r], t[r]), !0) : e === t;
}
const ar = Gt({
  hotkeys: [],
  activeScopes: [],
  // This array has to be empty instead of containing '*' as default, to check if the provider is set or not
  toggleScope: () => {
  },
  enableScope: () => {
  },
  disableScope: () => {
  }
}), vo = () => Yt(ar), bo = ({ initiallyActiveScopes: e = ["*"], children: t }) => {
  const [n, r] = V(e), [o, i] = V([]), c = R((a) => {
    r((h) => h.includes("*") ? [a] : Array.from(/* @__PURE__ */ new Set([...h, a])));
  }, []), d = R((a) => {
    r((h) => h.filter((p) => p !== a));
  }, []), u = R((a) => {
    r((h) => h.includes(a) ? h.filter((p) => p !== a) : h.includes("*") ? [a] : Array.from(/* @__PURE__ */ new Set([...h, a])));
  }, []), l = R((a) => {
    i((h) => [...h, a]);
  }, []), f = R((a) => {
    i((h) => h.filter((p) => !Ut(p, a)));
  }, []);
  return /* @__PURE__ */ s(
    ar.Provider,
    {
      value: { activeScopes: n, hotkeys: o, enableScope: c, disableScope: d, toggleScope: u },
      children: /* @__PURE__ */ s(go, { addHotkey: l, removeHotkey: f, children: t })
    }
  );
};
function yo(e) {
  const t = W(void 0);
  return Ut(t.current, e) || (t.current = e), t.current;
}
const mn = (e) => {
  e.stopPropagation(), e.preventDefault(), e.stopImmediatePropagation();
}, wo = typeof window < "u" ? qt : N;
function he(e, t, n, r) {
  const o = W(null), i = W(!1), c = Array.isArray(n) ? Array.isArray(r) ? void 0 : r : n, d = Qt(e) ? e.join(c == null ? void 0 : c.delimiter) : e, u = Array.isArray(n) ? n : Array.isArray(r) ? r : void 0, l = R(t, u ?? []), f = W(l);
  u ? f.current = l : f.current = t;
  const a = yo(c), { activeScopes: h } = vo(), p = ho();
  return wo(() => {
    if ((a == null ? void 0 : a.enabled) === !1 || !po(h, a == null ? void 0 : a.scopes))
      return;
    let m = [], y;
    const b = (v, M = !1) => {
      var w;
      if (!(uo(v) && !or(v, a == null ? void 0 : a.enableOnFormTags))) {
        if (o.current !== null) {
          const L = o.current.getRootNode();
          if ((L instanceof Document || L instanceof ShadowRoot) && L.activeElement !== o.current && !o.current.contains(L.activeElement)) {
            mn(v);
            return;
          }
        }
        (w = v.target) != null && w.isContentEditable && !(a != null && a.enableOnContentEditable) || Tt(d, a == null ? void 0 : a.delimiter).forEach((L) => {
          var C, E, k, A;
          if (L.includes((a == null ? void 0 : a.splitKey) ?? "+") && L.includes((a == null ? void 0 : a.sequenceSplitKey) ?? ">")) {
            console.warn(
              `Hotkey ${L} contains both ${(a == null ? void 0 : a.splitKey) ?? "+"} and ${(a == null ? void 0 : a.sequenceSplitKey) ?? ">"} which is not supported.`
            );
            return;
          }
          const x = Mt(
            L,
            a == null ? void 0 : a.splitKey,
            a == null ? void 0 : a.sequenceSplitKey,
            a == null ? void 0 : a.useKey,
            a == null ? void 0 : a.description,
            a == null ? void 0 : a.metadata
          );
          if (x.isSequence) {
            y = setTimeout(() => {
              m = [];
            }, (a == null ? void 0 : a.sequenceTimeoutMs) ?? 1e3);
            const P = x.useKey ? v.key : Te(v.code);
            if (tr(P.toLowerCase()))
              return;
            m.push(P);
            const O = (C = x.keys) == null ? void 0 : C[m.length - 1];
            if (P !== O) {
              m = [], y && clearTimeout(y);
              return;
            }
            m.length === ((E = x.keys) == null ? void 0 : E.length) && (f.current(v, x), y && clearTimeout(y), m = []);
          } else if (mo(v, x, a == null ? void 0 : a.ignoreModifiers) || (k = x.keys) != null && k.includes("*")) {
            if ((A = a == null ? void 0 : a.ignoreEventWhen) != null && A.call(a, v) || M && i.current)
              return;
            if (co(v, x, a == null ? void 0 : a.preventDefault), !lo(v, x, a == null ? void 0 : a.enabled)) {
              mn(v);
              return;
            }
            f.current(v, x), M || (i.current = !0);
          }
        });
      }
    }, T = (v) => {
      v.code !== void 0 && (nr(Te(v.code)), ((a == null ? void 0 : a.keydown) === void 0 && (a == null ? void 0 : a.keyup) !== !0 || a != null && a.keydown) && b(v));
    }, S = (v) => {
      v.code !== void 0 && (rr(Te(v.code)), i.current = !1, a != null && a.keyup && b(v, !0));
    }, g = o.current || (c == null ? void 0 : c.document) || document;
    return g.addEventListener("keyup", S, c == null ? void 0 : c.eventListenerOptions), g.addEventListener("keydown", T, c == null ? void 0 : c.eventListenerOptions), p && Tt(d, a == null ? void 0 : a.delimiter).forEach((v) => {
      p.addHotkey(
        Mt(
          v,
          a == null ? void 0 : a.splitKey,
          a == null ? void 0 : a.sequenceSplitKey,
          a == null ? void 0 : a.useKey,
          a == null ? void 0 : a.description,
          a == null ? void 0 : a.metadata
        )
      );
    }), () => {
      g.removeEventListener("keyup", S, c == null ? void 0 : c.eventListenerOptions), g.removeEventListener("keydown", T, c == null ? void 0 : c.eventListenerOptions), p && Tt(d, a == null ? void 0 : a.delimiter).forEach((v) => {
        p.removeHotkey(
          Mt(
            v,
            a == null ? void 0 : a.splitKey,
            a == null ? void 0 : a.sequenceSplitKey,
            a == null ? void 0 : a.useKey,
            a == null ? void 0 : a.description,
            a == null ? void 0 : a.metadata
          )
        );
      }), m = [], y && clearTimeout(y);
    };
  }, [d, a, h]), o;
}
const cr = "WEAVE_TIMELINE_HOTKEYS_SCOPE", xo = 16;
function at(e, t, n) {
  if (e <= t) return 0;
  const r = xo / n;
  return e - t + r;
}
function So(e, t, n) {
  return {
    start: e,
    end: Math.min(e + t, n)
  };
}
function Lo(e, t, n) {
  return t + e / n;
}
const Co = 80;
function To(e) {
  const t = 1 / e;
  return [
    [5 * t, t],
    // labels every 5 frames,  minor every 1 frame
    [10 * t, 5 * t],
    // labels every 10 frames, minor every 5 frames
    [1, 10 * t],
    // labels every 1s,        minor every 10 frames
    [5, 1],
    // labels every 5s,        minor every 1s
    [10, 5],
    // labels every 10s,       minor every 5s
    [30, 10],
    // labels every 30s,       minor every 10s
    [60, 30],
    // labels every 1min,      minor every 30s
    [300, 60],
    // labels every 5min,      minor every 1min
    [600, 300]
    // labels every 10min,     minor every 5min
  ];
}
function Mo(e, t) {
  const n = To(t);
  let r = n[n.length - 1];
  for (const d of n)
    if (d[0] * e >= Co) {
      r = d;
      break;
    }
  const [o, i] = r, c = i < 1;
  return { interval: i, majorInterval: o, showFrames: c };
}
function Eo(e, t, n, r, o) {
  const i = [], c = Math.round(r * o), d = Math.ceil(e / n) * n;
  for (let u = d; u <= t; u += n) {
    const l = Math.round(u * o) / o, a = Math.round(l * o) % c === 0;
    i.push({
      time: l,
      isMajor: a,
      label: a ? Io(l, o) : void 0
    });
  }
  return i;
}
function Io(e, t) {
  const n = Math.round(e * t), r = Math.round(t), o = n < 0, i = Math.abs(n), c = Math.floor(i / r), d = i - c * r, u = Math.floor(c / 3600), l = Math.floor(c % 3600 / 60), f = c % 60;
  if (d > 0) {
    const h = (p) => String(p).padStart(2, "0");
    return `${o ? "-" : ""}${h(f)}:${h(d)}`;
  }
  let a = "";
  return u > 0 && (a += `${u}h`), (u > 0 || l > 0) && (a += `${l}m`), a += `${f}s`, `${o ? "-" : ""}${a}`;
}
function lr(e, t, n, r, o, i, c = 0, d = o) {
  const u = e * t, l = o / u, f = (n - r) / (o / e), a = n - f * l, h = i / l, p = Math.max(c, at(d, l, h)), m = Math.max(c, Math.min(a, p));
  return { newZoom: u, newScroll: m };
}
const Le = 30, Po = 240, hn = 16, Jt = 36, Ml = 40, Re = 32, De = 4, gn = 6, Ht = 0.16, sr = 8, ur = 250, ko = 28, vn = 20, dr = 92, fr = 8, Z = 16, bn = 1.5, Do = 0.01, pr = 20, Ao = 1;
function ut(e, t) {
  let n = 0, r = e;
  for (const o of t) {
    const i = o.trimStart ?? 0, c = o.trimEnd ?? 0, d = o.startTime - i, u = o.startTime + o.duration + c;
    d < n && (n = d), u > r && (r = u);
  }
  return { start: n, end: r };
}
function en(e, t) {
  const { start: n, end: r } = ut(e, t);
  return Math.max(0, r - n);
}
function Et(e, t, n, r) {
  const { start: o, end: i } = ut(e, t), c = e / n, d = c > 0 ? r / c : 0, u = Math.max(o, at(i, c, d));
  return {
    visibleDuration: c,
    pps: d,
    minScroll: o,
    maxScroll: u
  };
}
function mr(e, t) {
  return t <= e || e <= 0 ? Ao : e / t;
}
function dt(e, t) {
  if (t <= 0) return 0;
  const n = Math.round(e * t);
  return n <= 0 ? 0 : (n - 1) / t;
}
function Oo() {
  return ro((e, t) => ({
    // Media metadata
    duration: 0,
    frameRate: 30,
    // Playback state
    currentTime: 0,
    isPlaying: !1,
    // Zoom/scroll state
    zoomLevel: 1,
    scrollPosition: 0,
    containerWidth: 0,
    // Tracks
    tracks: [],
    // Snap indicator
    snapIndicatorTime: null,
    // Drag guard
    draggingTrackIds: null,
    // Actions
    setMetadata(n, r = 30) {
      e({
        duration: n,
        frameRate: r,
        currentTime: 0,
        isPlaying: !1,
        zoomLevel: 1,
        scrollPosition: 0
      });
    },
    setDuration(n) {
      const { zoomLevel: r, scrollPosition: o, containerWidth: i, tracks: c } = t(), { minScroll: d, maxScroll: u } = Et(n, c, r, i);
      e({
        duration: n,
        scrollPosition: Math.max(d, Math.min(o, u))
      });
    },
    setCurrentTime(n) {
      const { duration: r, frameRate: o, currentTime: i, isPlaying: c, zoomLevel: d, scrollPosition: u } = t(), l = Math.max(0, Math.min(n, dt(r, o)));
      if (i === l) return l;
      if (c) {
        const f = r / d;
        if (l < u)
          return e({ currentTime: l, scrollPosition: l }), l;
        if (l > u + f)
          return e({ currentTime: l, scrollPosition: l - f * 0.9 }), l;
      }
      return e({ currentTime: l }), l;
    },
    setPlaying(n) {
      t().isPlaying !== n && e({ isPlaying: n });
    },
    setZoomLevel(n) {
      const { duration: r, frameRate: o, zoomLevel: i, scrollPosition: c, containerWidth: d, tracks: u } = t(), l = en(r, u), f = r * o / pr, a = mr(r, l), h = Math.min(a, i), p = Math.max(h, Math.min(n, f)), { minScroll: m, maxScroll: y } = Et(r, u, p, d);
      e({
        zoomLevel: p,
        scrollPosition: Math.max(m, Math.min(c, y))
      });
    },
    setScrollPosition(n) {
      const { duration: r, zoomLevel: o, containerWidth: i, tracks: c } = t(), { minScroll: d, maxScroll: u } = Et(r, c, o, i);
      e({ scrollPosition: Math.max(d, Math.min(n, u)) });
    },
    setContainerWidth(n) {
      e({ containerWidth: n });
    },
    setTrackStartTime(n, r) {
      const o = t().tracks.map((i) => i.id === n ? { ...i, startTime: r } : i);
      e({ tracks: o });
    },
    setTrackTrim(n, r) {
      const o = t().tracks.map((i) => i.id === n ? { ...i, ...r } : i);
      e({ tracks: o });
    },
    setTracks(n) {
      const { draggingTrackIds: r } = t();
      if (r != null && r.length > 0) {
        const i = new Set(r), c = t().tracks;
        n = n.map((d) => {
          if (!i.has(d.id)) return d;
          const u = c.find((l) => l.id === d.id);
          return u ? {
            ...d,
            startTime: u.startTime,
            duration: u.duration,
            trimStart: u.trimStart,
            trimEnd: u.trimEnd
          } : d;
        });
      }
      e({ tracks: n });
    },
    setSnapIndicatorTime(n) {
      e({ snapIndicatorTime: n });
    },
    setDraggingTrackIds(n) {
      e({ draggingTrackIds: n });
    }
  }));
}
const zt = (e) => e.duration / e.zoomLevel, oe = (e) => {
  const t = e.duration / e.zoomLevel;
  return t > 0 ? e.containerWidth / t : 0;
}, Ro = (e) => dt(e.duration, e.frameRate), Fo = (e) => {
  const t = Math.round(e.duration * e.frameRate);
  return t <= 0 ? !0 : Math.round(e.currentTime * e.frameRate) >= t - 1;
}, hr = (e) => e.duration * e.frameRate / pr, ct = (e) => ut(e.duration, e.tracks).start, lt = (e) => ut(e.duration, e.tracks).end, jt = (e) => en(e.duration, e.tracks), gr = (e) => mr(e.duration, en(e.duration, e.tracks)), vr = Gt(null);
function G() {
  const e = Yt(vr);
  if (!e)
    throw new Error("useTimelineContext must be used within a <TimelineProvider>");
  return e;
}
function I(e) {
  const { store: t } = G();
  return oo(t, e);
}
function te() {
  return G().fplMigration;
}
function br() {
  const { fplMigration: e } = G();
  return e ? { className: "timeline-fpl-theme", "data-editor-theme": "weave", "data-preferred-theme": "dark" } : {};
}
function El({
  children: e,
  duration: t,
  frameRate: n = 30,
  currentTime: r,
  isPlaying: o,
  onSeek: i,
  onPlayingChange: c,
  tracks: d,
  selectedTrackIds: u,
  onTrackLockToggle: l,
  onTrackMuteToggle: f,
  onTrackVisibilityToggle: a,
  onTrackStartTimeChange: h,
  onTrackTrimChange: p,
  onTrackFadeDurationChange: m,
  onTrackFadeDurationCancel: y,
  onTrackSelect: b,
  onTrackRightClick: T,
  onTrackReorder: S,
  onTrackToggleCollapse: g,
  onTrackRename: v,
  allowNesting: M = !1,
  fplMigration: w = !1,
  themeMode: L = "dark"
}) {
  const x = ot(() => Oo(), []), C = W(!1);
  N(() => {
    if (!t || !Number.isFinite(t)) return;
    const O = x.getState();
    O.duration === t && O.frameRate === n || (C.current = !0, O.setMetadata(t, n), C.current = !1);
  }, [x, t, n]);
  const E = W(r), k = W(o);
  E.current = r, k.current = o, N(() => {
    let O;
    function B() {
      const F = E.current;
      if (F != null) {
        const { currentTime: le, duration: Q, frameRate: ie } = x.getState(), U = Math.max(0, Math.min(F, dt(Q, ie)));
        le !== U && x.getState().setCurrentTime(F);
      }
      const H = k.current;
      H != null && x.getState().isPlaying !== H && (C.current = !0, x.getState().setPlaying(H), C.current = !1), O = requestAnimationFrame(B);
    }
    return O = requestAnimationFrame(B), () => cancelAnimationFrame(O);
  }, [x]), N(() => {
    let O = x.getState().isPlaying;
    return x.subscribe((B) => {
      B.isPlaying !== O && (O = B.isPlaying, C.current || c(B.isPlaying));
    });
  }, [x, c]), N(() => {
    d && x.getState().setTracks(d);
  }, [d, x]);
  const A = ot(() => u ?? [], [u]), P = ot(
    () => ({
      store: x,
      onSeek: i,
      onTrackLockToggle: l,
      onTrackMuteToggle: f,
      onTrackVisibilityToggle: a,
      onTrackStartTimeChange: h,
      onTrackTrimChange: p,
      onTrackFadeDurationChange: m,
      onTrackFadeDurationCancel: y,
      onTrackSelect: b,
      onTrackRightClick: T,
      onTrackReorder: S,
      onTrackToggleCollapse: g,
      onTrackRename: v,
      selectedTrackIds: A,
      allowNesting: M,
      fplMigration: w,
      themeMode: L
    }),
    [
      x,
      i,
      l,
      f,
      a,
      h,
      p,
      m,
      y,
      b,
      T,
      S,
      g,
      v,
      A,
      M,
      w,
      L
    ]
  );
  return /* @__PURE__ */ s(bo, { initiallyActiveScopes: [cr], children: /* @__PURE__ */ s(vr.Provider, { value: P, children: /* @__PURE__ */ s(
    "div",
    {
      className: w ? "timeline-fpl-theme" : void 0,
      "data-editor-theme": w ? "weave" : void 0,
      "data-preferred-theme": w ? L : void 0,
      style: { display: "contents" },
      children: e
    }
  ) }) });
}
const Bo = typeof window < "u", Wo = {
  matches: !1,
  addEventListener: () => {
  },
  removeEventListener: () => {
  }
};
function Ho(e) {
  return Bo ? window.matchMedia(e) : Wo;
}
const zo = Ho("screen and (min-resolution: 2dppx)");
function jo(e) {
  const [t, n] = V(e.matches);
  return N(() => {
    function r(o) {
      n(o.matches);
    }
    return e.addEventListener("change", r), () => e.removeEventListener("change", r);
  }, [e]), t;
}
function tn() {
  return jo(zo);
}
const Vo = j(function(t) {
  return tn() ? /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24L",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      d: "M15.647 10.147a.5.5 0 1 1 .707.707l-4 4a.5.5 0 0 1-.707 0l-4-4a.5.5 0 1 1 .707-.707L12 13.793z"
    })
  }) : /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24L",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      d: "M15.147 10.147a.5.5 0 1 1 .707.707l-4 4a.5.5 0 0 1-.707 0l-4-4a.5.5 0 1 1 .707-.707l3.646 3.646z"
    })
  });
}), No = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      fillRule: "evenodd",
      d: "M6 12c0-.066.054-.358.313-.825a5.9 5.9 0 0 1 1.12-1.414C8.443 8.816 9.956 8 12 8s3.558.816 4.566 1.76c.508.477.88.98 1.121 1.415.258.467.313.76.313.825 0 .066-.055.358-.313.825-.24.435-.613.938-1.12 1.414C15.557 15.184 14.044 16 12 16s-3.558-.816-4.566-1.76a5.9 5.9 0 0 1-1.121-1.415C6.055 12.358 6 12.065 6 12m-1 0c0-1.25 2.333-5 7-5s7 3.75 7 5-2.333 5-7 5-7-3.75-7-5m8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m1 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
      clipRule: "evenodd"
    })
  });
}), $o = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      fillRule: "evenodd",
      d: "M6 7.5A1.5 1.5 0 0 1 7.5 6a.5.5 0 0 1 0 1 .5.5 0 0 0-.5.5.5.5 0 0 1-1 0m3-1a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m3.5 0A.5.5 0 0 1 13 6h1.5a.5.5 0 0 1 0 1H13a.5.5 0 0 1-.5-.5m3.5 0a.5.5 0 0 1 .5-.5A1.5 1.5 0 0 1 18 7.5a.5.5 0 0 1-1 0 .5.5 0 0 0-.5-.5.5.5 0 0 1-.5-.5M6.5 9a.5.5 0 0 1 .5.5V11a.5.5 0 0 1-1 0V9.5a.5.5 0 0 1 .5-.5m11 0a.5.5 0 0 1 .5.5V11a.5.5 0 0 1-1 0V9.5a.5.5 0 0 1 .5-.5m-11 3.5a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-1 0V13a.5.5 0 0 1 .5-.5m11 0a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-1 0V13a.5.5 0 0 1 .5-.5M6.5 16a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 0 1A1.5 1.5 0 0 1 6 16.5a.5.5 0 0 1 .5-.5m11 0a.5.5 0 0 1 .5.5 1.5 1.5 0 0 1-1.5 1.5.5.5 0 0 1 0-1 .5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5M9 17.5a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H9.5a.5.5 0 0 1-.5-.5m3.5 0a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1H13a.5.5 0 0 1-.5-.5",
      clipRule: "evenodd"
    })
  });
}), _o = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24L",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      fillRule: "evenodd",
      d: "M12.997 8.62H13V10a.5.5 0 0 0 1 0V5.923A1 1 0 0 1 15.997 6v2.62H16V10a.5.5 0 0 0 1 0V8a1 1 0 1 1 2 0v.62h.01v4.743q0 .074-.01.143l-.007.07a6.773 6.773 0 0 1-6.756 6.287q-.243 0-.47-.01c-1.535-.07-2.885-.786-4.107-1.92-1.23-1.141-2.28-2.66-3.188-4.219-.289-.495-.486-.88-.555-1.193a.6.6 0 0 1-.016-.263c.007-.029.022-.071.087-.135a.57.57 0 0 1 .517-.173c.224.03.518.165.807.434l.001.002 1 .945A1 1 0 0 0 8 12.604V6a1 1 0 0 1 2 0v4a.5.5 0 0 0 1 0V5a1 1 0 1 1 2 0v.89l-.003.11zM7 8.5V6a2 2 0 0 1 3.112-1.662 2 2 0 0 1 3.775-.002A2 2 0 0 1 16.997 6v.27A2 2 0 0 1 20 8v.5h.01v4.863q0 .144-.02.284a7.773 7.773 0 0 1-7.753 7.216q-.266 0-.516-.012c-3.682-.167-6.256-3.449-8.113-6.633-.565-.969-1.11-2.043-.316-2.812.793-.77 1.898-.505 2.705.25l.003.003 1 .945z",
      clipRule: "evenodd"
    })
  });
}), Ko = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      fillRule: "evenodd",
      d: "M5.5 9c.276 0 .533.223.641.477q.065.153.172.348c.24.435.613.938 1.121 1.414C8.442 12.184 9.954 13 12 13s3.558-.816 4.566-1.76c.508-.477.88-.98 1.121-1.415q.107-.195.171-.348c.11-.254.366-.477.642-.477s.495.225.417.49c-.202.682-.77 1.65-1.705 2.515l1.142 1.141a.5.5 0 0 1-.708.708l-1.217-1.218a7.4 7.4 0 0 1-1.89.958l.446 1.785a.5.5 0 0 1-.97.242l-.443-1.77A8 8 0 0 1 12 14a8 8 0 0 1-1.572-.15l-.443 1.771a.5.5 0 0 1-.97-.242l.446-1.785a7.4 7.4 0 0 1-1.89-.958l-1.217 1.218a.5.5 0 0 1-.708-.708l1.142-1.142c-.935-.864-1.503-1.832-1.705-2.514-.078-.265.14-.49.417-.49",
      clipRule: "evenodd"
    })
  });
}), Xo = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      d: "M16 6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zM8 7a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm1.725 4.582a.5.5 0 0 1 .629.064l3.5 3.5a.5.5 0 1 1-.707.707L10 12.708l-1.146 1.146a.5.5 0 1 1-.708-.707l1.5-1.5zM14 8a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
    })
  });
}), Zo = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      fillRule: "evenodd",
      d: "M10 12H8.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5zm1-1h-1V9a2 2 0 1 1 4 0v2zm1-5a3 3 0 0 1 3 3v2h.5a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 7 16.5v-4A1.5 1.5 0 0 1 8.5 11H9V9a3 3 0 0 1 3-3",
      clipRule: "evenodd"
    })
  });
}), Go = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      d: "M12 5a3 3 0 0 1 3 3v3h.5a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 7 16.5v-4A1.5 1.5 0 0 1 8.5 11H14V8a2 2 0 1 0-4 0v.5a.5.5 0 0 1-1 0V8a3 3 0 0 1 3-3m-3.5 7a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5z"
    })
  });
}), Yo = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24L",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      d: "M4.586 4.586a2 2 0 0 1 2.005-.497l.14.05 13 5.107a2 2 0 0 1 1.267 1.779v.159a2 2 0 0 1-1.26 1.782l-.15.053-5.024 1.545-1.545 5.024a2 2 0 0 1-1.677 1.398l-.158.012a2 2 0 0 1-1.938-1.267l-5.107-13a2 2 0 0 1 .447-2.145m1.78.484a1 1 0 0 0-1.073.223l-.097.112a1 1 0 0 0-.127.96l5.108 13a1 1 0 0 0 .811.628l.158.006a1 1 0 0 0 .859-.558l.058-.147 1.7-5.53 5.531-1.701a1 1 0 0 0 .687-.76l.018-.157a1 1 0 0 0-.492-.9l-.142-.069z"
    })
  });
}), qo = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24L",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      d: "M8 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm10 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"
    })
  });
}), Qo = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24L",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      d: "M4.886 3.21a1 1 0 0 1 .812-.19l7.698 1.56.338.076a7.67 7.67 0 0 1 5.806 7.266v.346l-.008.329 1.197 1.197a1 1 0 0 1 0 1.414l-5.523 5.522a1 1 0 0 1-1.413 0l-1.198-1.197-.328.008a7.67 7.67 0 0 1-7.612-5.806l-.077-.338L3.02 5.7a1 1 0 0 1 .274-.906l1.5-1.5zm.674 9.99a6.666 6.666 0 0 0 6.383 5.342h.3l.756-.018 1.5 1.5 5.523-5.522-1.5-1.5.018-.756a6.67 6.67 0 0 0-5.048-6.619l-.295-.066L5.5 4l-.396.397 5.16 5.16A3 3 0 0 1 12 9.001 3.001 3.001 0 0 1 12 15a3 3 0 0 1-2.444-4.737l-5.16-5.16L4 5.5zM12 10.001a2 2 0 0 0-2 2l.01.204a2 2 0 0 0 1.786 1.785L12 14a2 2 0 0 0 1.989-1.795l.01-.204a2 2 0 0 0-1.795-1.99z"
    })
  });
}), Uo = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24L",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      d: "M6 5.903C6 4.43 7.604 3.518 8.87 4.27l10.152 6.028c1.306.776 1.303 2.669-.005 3.441l-10.15 5.996C7.6 20.482 6 19.569 6 18.098z"
    })
  });
}), Jo = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24L",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      fillRule: "evenodd",
      d: "M3 9c0 1.521.566 2.91 1.5 3.968a6 6 0 0 0 4 2.011.47.47 0 0 0 .5-.479.536.536 0 0 0-.49-.524H8.5a5 5 0 0 1-3.218-1.632A5 5 0 1 1 13.975 8.5l.001.008.013.073A.536.536 0 0 0 14.5 9a.47.47 0 0 0 .48-.5 6 6 0 0 0-2.012-4A6 6 0 0 0 3 9m9 2h7a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1m-2 1a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2z",
      clipRule: "evenodd"
    })
  });
}), ei = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      d: "M6.499 6.5a.5.5 0 0 0-.5.5v10a.5.5 0 1 0 1 0V7a.5.5 0 0 0-.5-.5M18 8.103a1.6 1.6 0 0 0-2.404-1.384L8.746 10.7a1.5 1.5 0 0 0 0 2.594l6.85 3.981A1.6 1.6 0 0 0 18 15.894zm-1.901-.52a.6.6 0 0 1 .901.52v7.79a.6.6 0 0 1-.901.52L9.247 12.43a.5.5 0 0 1 0-.864z"
    })
  });
}), ti = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      d: "M17.5 6.5a.5.5 0 0 1 .5.5v10a.5.5 0 1 1-1 0V7a.5.5 0 0 1 .5-.5M5.999 8.103a1.6 1.6 0 0 1 2.404-1.384l6.85 3.982a1.5 1.5 0 0 1 0 2.594l-6.85 3.981A1.6 1.6 0 0 1 6 15.894zm1.901-.52a.6.6 0 0 0-.901.52v7.79a.6.6 0 0 0 .901.52l6.852-3.983a.5.5 0 0 0 0-.864z"
    })
  });
}), ni = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      d: "M17.5 6.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 1 0V7a.5.5 0 0 0-.5-.5m-2.499 1.603a1.6 1.6 0 0 0-2.404-1.384L5.747 10.7a1.5 1.5 0 0 0 0 2.594l6.85 3.981A1.6 1.6 0 0 0 15 15.894zm-1.901-.52a.6.6 0 0 1 .901.52v7.79a.6.6 0 0 1-.901.52L6.248 12.43a.5.5 0 0 1 0-.864z"
    })
  });
}), ri = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      d: "M6.5 6.5A.5.5 0 0 1 7 7v10a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5m2.499 1.603a1.6 1.6 0 0 1 2.404-1.384l6.85 3.982a1.5 1.5 0 0 1 0 2.594l-6.85 3.981A1.6 1.6 0 0 1 9 15.894zm1.901-.52a.6.6 0 0 0-.901.52v7.79a.6.6 0 0 0 .901.52l6.852-3.983a.5.5 0 0 0 0-.864z"
    })
  });
}), oi = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      d: "M12.147 11.975a.5.5 0 0 1 .853.353V18a1 1 0 0 1-1.707.707l-2.704-2.704L8.582 16a.19.19 0 0 1-.135-.325l.338-.339a.39.39 0 0 1 .55 0l2.648 2.647c.007.006.017.001.017-.007v-5.647a.5.5 0 0 1 .146-.353m3-5.829a.5.5 0 1 1 .707.708l-11 11a.5.5 0 0 1-.708-.707zm-3.854-.854A1 1 0 0 1 13 5.999v.673a.5.5 0 0 1-1 0v-.649c0-.008-.01-.013-.017-.007l-2.98 2.98L8.996 9H6.5a.5.5 0 0 0-.5.5v4.173a.5.5 0 0 1-.146.353l-.573.572c-.105.105-.281.051-.281-.098v-5A1.5 1.5 0 0 1 6.5 8h2.082l.007-.003z"
    })
  });
}), ii = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      fillRule: "evenodd",
      d: "m9 15 2 2 1 1V6l-1 1-2 2H6.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5zm2.293-9.707L8.586 8H6.5A1.5 1.5 0 0 0 5 9.5v5A1.5 1.5 0 0 0 6.5 16h2.086l2.707 2.707A1 1 0 0 0 13 18V6a1 1 0 0 0-1.707-.707m3.249 12.109c-.289.055-.542-.178-.542-.472v-.01c0-.255.193-.466.442-.519a4.502 4.502 0 0 0 0-8.802.54.54 0 0 1-.442-.52v-.01c0-.293.253-.526.542-.47a5.502 5.502 0 0 1 0 10.802m.02-2.066c-.29.092-.562-.144-.562-.448v-.03c0-.237.17-.437.392-.522a2.5 2.5 0 0 0 0-4.672C14.17 9.579 14 9.379 14 9.14v-.029c0-.304.272-.54.562-.448a3.502 3.502 0 0 1 0 6.672m.026-2.303c-.238.25-.588.02-.588-.325v-1.416c0-.345.35-.575.588-.325a1.5 1.5 0 0 1 0 2.066",
      clipRule: "evenodd"
    })
  });
}), ai = j(function(t) {
  return tn() ? /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      fillRule: "evenodd",
      d: "M6 6.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5V9a.5.5 0 0 1-1 0V7h-4.5v10h2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h2V7H7v2a.5.5 0 0 1-1 0z",
      clipRule: "evenodd"
    })
  }) : /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      fillRule: "evenodd",
      d: "M6 7.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0V8h-4v8h1.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1H11V8H7v1.5a.5.5 0 0 1-1 0z",
      clipRule: "evenodd"
    })
  });
}), ci = j(function(t) {
  return tn() ? /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24L",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      d: "M19.5 4a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V5h-6.5v14H15a.5.5 0 0 1 0 1H9a.5.5 0 0 1 0-1h2.5V5H5v2.5a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5z"
    })
  }) : /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24L",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      fillRule: "evenodd",
      d: "M4 5.5a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V6h-6v12h2.5a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1H11V6H5v2.5a.5.5 0 0 1-1 0z",
      clipRule: "evenodd"
    })
  });
}), li = j(function(t) {
  return /* @__PURE__ */ s("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ...t,
    "data-fpl-icon-size": "24",
    children: /* @__PURE__ */ s("path", {
      fill: "var(--fpl-icon-color, var(--color-icon))",
      fillRule: "evenodd",
      d: "M8 7h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1M6 8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zm4.996 1.132A1 1 0 0 0 9.5 10v4a1 1 0 0 0 1.496.868l3.5-2a1 1 0 0 0 0-1.736zm.504 4.297-1 .571v-4l1 .571 1.492.853L14 12l-1.008.576z",
      clipRule: "evenodd"
    })
  });
}), yr = "var(--Black84)", fe = "var(--Black92)", si = "var(--Black40_T)", K = "var(--White100)", Xe = "var(--White80_T)", ce = "var(--White64_T)", Ze = "var(--White40_T)", ui = "var(--White16_T)", _ = "var(--White08_T)", nn = "var(--White04_T)", Fe = "var(--weavy-theme-white100)", di = "#F1A0FA", fi = "#EF9092", wr = "#4452F2", pi = "#FFFFFF66", mi = "#FFFFFF", hi = "#8D95A0", gi = "#212126", ft = "var(--color-bg, #2c2c2c)", vi = "var(--color-bg-tertiary, #444)", bi = "var(--color-bg-secondary, #383838)", yi = "var(--color-bg-selected, #757575)", xr = "var(--color-text-tertiary, rgba(255, 255, 255, 0.4))", Sr = "var(--color-bg-elevated, #1e1e1e)", Lr = "var(--color-bg-brand, #ffffff)", Cr = "var(--color-text-onbrand, #2c2c2c)", Tr = "var(--color-text-onbrand-secondary, rgba(44, 44, 44, 0.64))", wi = "var(--color-bg-tooltip, #1e1e1e)", xi = "var(--color-text-tooltip, #ffffff)";
function de(e) {
  return e.locked || (e.lockedByAncestor ?? !1);
}
function X(e) {
  return e === "video" || e === "audio";
}
function Mr(e, t) {
  const n = new Set(e), r = new Map(t.map((o) => [o.id, o.parentId ?? null]));
  return e.filter((o) => {
    let i = r.get(o);
    for (; i != null; ) {
      if (n.has(i))
        return !1;
      i = r.get(i);
    }
    return !0;
  });
}
function Si({
  togglePlay: e,
  stepFrame: t,
  jumpToStart: n,
  jumpToEnd: r,
  onHotkeyUsed: o
}) {
  const i = I((p) => p.isPlaying), c = I((p) => p.setPlaying), { store: d, selectedTrackIds: u, onTrackStartTimeChange: l } = G(), f = R(() => {
    i && c(!1);
  }, [i, c]), a = { enableOnFormTags: !1, scopes: [cr] }, h = R(
    (p) => {
      const m = Mr(u, p).filter((b) => {
        const T = p.find((S) => S.id === b);
        return T !== void 0 && !de(T);
      }), y = p.find((b) => b.id === m[0]);
      return y ? [y, m] : void 0;
    },
    [u]
  );
  he(
    "space",
    (p) => {
      p.repeat || (p.preventDefault(), e(), o == null || o("play-pause"));
    },
    a
  ), he(
    "meta+left, ctrl+left",
    (p) => {
      p.preventDefault(), t(-1), o == null || o("step-frame");
    },
    a
  ), he(
    "meta+right, ctrl+right",
    (p) => {
      p.preventDefault(), t(1), o == null || o("step-frame");
    },
    a
  ), he(
    "meta+shift+left, ctrl+shift+left",
    (p) => {
      p.preventDefault(), t(-10), o == null || o("step-ten-frames");
    },
    a
  ), he(
    "meta+shift+right, ctrl+shift+right",
    (p) => {
      p.preventDefault(), t(10), o == null || o("step-ten-frames");
    },
    a
  ), he(
    "meta+shift+alt+left, ctrl+shift+alt+left",
    (p) => {
      p.repeat || (p.preventDefault(), n(), o == null || o("jump-to-start-end"));
    },
    a
  ), he(
    "meta+shift+alt+right, ctrl+shift+alt+right",
    (p) => {
      p.repeat || (p.preventDefault(), r(), o == null || o("jump-to-start-end"));
    },
    a
  ), he(
    "BracketLeft",
    () => {
      const { currentTime: p, tracks: m } = d.getState(), y = h(m);
      if (!y) return;
      const [b, T] = y;
      f();
      const S = p - b.startTime;
      l(T, S, !1), o == null || o("snap-start-to-playhead");
    },
    a
  ), he(
    "BracketRight",
    () => {
      const { currentTime: p, tracks: m } = d.getState(), y = h(m);
      if (!y) return;
      const [b, T] = y;
      f();
      const S = p - b.duration - b.startTime;
      l(T, S, !1), o == null || o("snap-end-to-playhead");
    },
    a
  );
}
function $(e, t) {
  return function(r) {
    if (!te())
      return /* @__PURE__ */ s(e, { ...r });
    const { width: i, height: c, viewBox: d, style: u, title: l, ...f } = r, { width: a, height: h, ...p } = u ?? {};
    return /* @__PURE__ */ s(
      t,
      {
        ...f,
        ...l ? { role: "img", "aria-label": l } : null,
        style: Object.keys(p).length > 0 ? p : void 0
      }
    );
  };
}
const Li = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s(
    "path",
    {
      d: "M5.27734 2.44019C5.45049 2.44385 5.62082 2.48223 5.77832 2.55151L5.93066 2.63062L5.93262 2.63159L19.4375 10.8914C19.6282 11.0068 19.7861 11.1699 19.8955 11.364C20.0049 11.5581 20.0624 11.777 20.0625 11.9998C20.0625 12.2226 20.0049 12.4423 19.8955 12.6365C19.7865 12.8298 19.629 12.9909 19.4395 13.1062L5.93262 21.3679L5.93066 21.3689C5.7334 21.4886 5.50804 21.5544 5.27734 21.5593C5.04685 21.5642 4.81917 21.5084 4.61719 21.3972C4.46562 21.3138 4.33197 21.2014 4.22461 21.0671L4.12598 20.9255C4.00679 20.728 3.94178 20.5019 3.9375 20.2712V3.72827L3.95215 3.5564C3.97784 3.38663 4.03674 3.22294 4.12598 3.07495C4.24522 2.8774 4.41505 2.71457 4.61719 2.60327C4.81921 2.49208 5.04679 2.43536 5.27734 2.44019Z",
      fill: "currentColor"
    }
  )
] }), Ci = $(Li, Uo), Ti = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s("g", { clipPath: "url(#clip0_822_591)", children: /* @__PURE__ */ s(
    "path",
    {
      d: "M9 3.96533C9.72479 3.96533 10.3124 4.55307 10.3125 5.27783V20.2778C10.3125 21.0027 9.72487 21.5903 9 21.5903H5.25C4.52513 21.5903 3.9375 21.0027 3.9375 20.2778V5.27783C3.93763 4.55307 4.52521 3.96533 5.25 3.96533H9ZM18.75 3.96533C19.4748 3.96533 20.0624 4.55307 20.0625 5.27783V20.2778C20.0625 21.0027 19.4749 21.5903 18.75 21.5903H15C14.2751 21.5903 13.6875 21.0027 13.6875 20.2778V5.27783C13.6876 4.55307 14.2752 3.96533 15 3.96533H18.75Z",
      fill: "currentColor"
    }
  ) }),
  /* @__PURE__ */ s("defs", { children: /* @__PURE__ */ s("clipPath", { id: "clip0_822_591", children: /* @__PURE__ */ s("rect", { width: "24", height: "24", fill: "white", transform: "translate(0 0.777832)" }) }) })
] }), Mi = $(Ti, qo), Er = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s(
    "path",
    {
      d: "M6 6.02246V18.0225",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M9 6.75811V17.2862C9.00114 17.4188 9.0378 17.5486 9.10616 17.6622C9.17451 17.7758 9.27206 17.869 9.38865 17.9321C9.50524 17.9951 9.63661 18.0258 9.76909 18.0209C9.90156 18.016 10.0303 17.9756 10.1419 17.904L18.4097 12.64C18.5139 12.574 18.5997 12.4828 18.6591 12.3748C18.7186 12.2668 18.7497 12.1455 18.7497 12.0222C18.7497 11.8989 18.7186 11.7776 18.6591 11.6696C18.5997 11.5615 18.5139 11.4703 18.4097 11.4044L10.1419 6.1403C10.0303 6.06873 9.90156 6.02839 9.76909 6.02346C9.63661 6.01854 9.50524 6.04921 9.38865 6.11229C9.27206 6.17538 9.17451 6.26856 9.10616 6.38214C9.0378 6.49572 9.00114 6.62555 9 6.75811Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Ei = $(Er, ri), Ii = ({ style: e, ...t }) => /* @__PURE__ */ s(Er, { style: { transform: "scaleX(-1)", ...e }, ...t }), Pi = $(Ii, ni), Ir = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s(
    "path",
    {
      d: "M6 6.75811V17.2862C6.00114 17.4188 6.0378 17.5486 6.10616 17.6622C6.17451 17.7758 6.27206 17.869 6.38865 17.9321C6.50524 17.9951 6.63661 18.0258 6.76909 18.0209C6.90156 18.016 7.0303 17.9756 7.1419 17.904L15.4097 12.64C15.5139 12.574 15.5997 12.4828 15.6591 12.3748C15.7186 12.2668 15.7497 12.1455 15.7497 12.0222C15.7497 11.8989 15.7186 11.7776 15.6591 11.6696C15.5997 11.5615 15.5139 11.4703 15.4097 11.4044L7.1419 6.1403C7.0303 6.06873 6.90156 6.02839 6.76909 6.02346C6.63661 6.01854 6.50524 6.04921 6.38865 6.11229C6.27206 6.17538 6.17451 6.26856 6.10616 6.38214C6.0378 6.49572 6.00114 6.62555 6 6.75811Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M18 6.02246V18.0225",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), ki = $(Ir, ti), Di = ({ style: e, ...t }) => /* @__PURE__ */ s(Ir, { style: { transform: "scaleX(-1)", ...e }, ...t }), Ai = $(Di, ei), Oe = Me(({ style: e, component: t, ...n }, r) => {
  switch (t) {
    case "span":
      return /* @__PURE__ */ s("span", { ref: r, style: { display: "flex", ...e }, ...n });
    case "button":
      return /* @__PURE__ */ s("button", { ref: r, style: { display: "flex", ...e }, ...n });
    default:
      return /* @__PURE__ */ s("div", { ref: r, style: { display: "flex", ...e }, ...n });
  }
});
Oe.displayName = "Flex";
const pt = Me(({ style: e, ...t }, n) => /* @__PURE__ */ s(Oe, { ref: n, style: { flexDirection: "column", ...e }, ...t }));
pt.displayName = "FlexCol";
const Pr = Me(({ style: e, ...t }, n) => /* @__PURE__ */ s(Oe, { ref: n, style: { justifyContent: "center", ...e }, ...t }));
Pr.displayName = "FlexCenHor";
const re = Me(({ style: e, ...t }, n) => /* @__PURE__ */ s(Oe, { ref: n, style: { alignItems: "center", ...e }, ...t }));
re.displayName = "FlexCenVer";
const be = Me(({ style: e, ...t }, n) => /* @__PURE__ */ s(Pr, { ref: n, style: { alignItems: "center", ...e }, ...t }));
be.displayName = "FlexCenHorVer";
const kr = Me(({ style: e, ...t }, n) => /* @__PURE__ */ s(pt, { ref: n, style: { alignItems: "center", ...e }, ...t }));
kr.displayName = "FlexColCenHor";
const Oi = Me(({ style: e, ...t }, n) => /* @__PURE__ */ s(pt, { ref: n, style: { justifyContent: "center", ...e }, ...t }));
Oi.displayName = "FlexColCenVer";
const Ri = Me(({ style: e, ...t }, n) => /* @__PURE__ */ s(kr, { ref: n, style: { justifyContent: "center", ...e }, ...t }));
Ri.displayName = "FlexColCenHorVer";
function Ce({ children: e, onClick: t, size: n = 24, disabled: r, ariaLabel: o, stopPropagation: i }) {
  const c = te();
  return /* @__PURE__ */ s(
    be,
    {
      component: "button",
      className: "icon-btn",
      style: {
        width: n,
        height: n,
        color: r ? c ? xr : Ze : c ? K : Xe,
        borderRadius: 4
      },
      disabled: r,
      "aria-label": o,
      onClick: (l) => {
        i && l.stopPropagation(), t();
      },
      onMouseDown: (l) => {
        i && l.stopPropagation();
      },
      children: e
    }
  );
}
const Fi = 800;
function Dr({ content: e, children: t }) {
  const [n, r] = V(!1), o = W(null), i = te(), c = i ? wi : yr, d = () => {
    o.current !== null && (clearTimeout(o.current), o.current = null);
  };
  return N(() => d, []), e == null ? /* @__PURE__ */ s(st, { children: t }) : /* @__PURE__ */ D(
    "div",
    {
      style: { position: "relative", display: "inline-flex" },
      onMouseEnter: () => {
        d(), o.current = setTimeout(() => r(!0), Fi);
      },
      onMouseLeave: () => {
        d(), r(!1);
      },
      children: [
        t,
        n && /* @__PURE__ */ s(
          "div",
          {
            role: "tooltip",
            style: {
              position: "absolute",
              bottom: "calc(100% + 6px)",
              left: "50%",
              transform: "translateX(-50%)",
              background: c,
              color: i ? xi : void 0,
              border: `1px solid ${nn}`,
              borderRadius: 4,
              padding: "2px 4px",
              whiteSpace: "nowrap",
              pointerEvents: "none",
              zIndex: 10
            },
            children: e
          }
        )
      ]
    }
  );
}
function It({ options: e, value: t, onChange: n, size: r = 24 }) {
  const [o, i] = V(null), c = te();
  return /* @__PURE__ */ s(st, { children: e.map((d, u) => {
    const l = d.value === t, f = o === u;
    let a = "transparent", h = c ? K : Xe;
    l && f || l ? (a = Fe, h = fe) : f && (a = _, h = K);
    const p = c ? { "--fpl-icon-color": h } : {};
    return /* @__PURE__ */ s(Dr, { content: d.tooltip, children: /* @__PURE__ */ s(
      be,
      {
        component: "button",
        style: {
          width: r,
          height: r,
          padding: 0,
          borderRadius: 4,
          background: a,
          color: h,
          ...p
        },
        "aria-label": d.ariaLabel,
        onClick: () => n(d.value),
        onMouseEnter: () => i(u),
        onMouseLeave: () => i(null),
        children: d.icon
      }
    ) }, u);
  }) });
}
const Bi = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s(
    "path",
    {
      d: "M12.7459 12.7421L20.4662 10.5859C20.6175 10.5395 20.7503 10.4465 20.8455 10.3201C20.9407 10.1936 20.9935 10.0403 20.9963 9.8821C20.9992 9.72386 20.9518 9.56878 20.8612 9.43907C20.7705 9.30935 20.6411 9.21165 20.4915 9.15994L3.9915 3.03994C3.85914 2.99493 3.71682 2.9878 3.58063 3.01937C3.44443 3.05095 3.31977 3.11996 3.22072 3.21863C3.12166 3.31729 3.05216 3.44168 3.02005 3.57775C2.98794 3.71382 2.9945 3.85616 3.039 3.98869L9.159 20.4887C9.2107 20.6383 9.30841 20.7677 9.43812 20.8584C9.56783 20.949 9.72291 20.9964 9.88115 20.9935C10.0394 20.9907 10.1927 20.9379 10.3191 20.8427C10.4455 20.7475 10.5386 20.6147 10.5849 20.4634L12.7459 12.7421Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Wi = $(Bi, Yo), Hi = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s(
    "path",
    {
      d: "M15.7501 7.125C15.7501 6.62772 15.9477 6.15081 16.2993 5.79917C16.6509 5.44754 17.1279 5.25 17.6251 5.25C18.1224 5.25 18.5993 5.44754 18.951 5.79917C19.3026 6.15081 19.5001 6.62772 19.5001 7.125V14.25C19.5001 15.2349 19.3061 16.2102 18.9292 17.1201C18.5523 18.0301 17.9999 18.8569 17.3034 19.5533C16.607 20.2497 15.7802 20.8022 14.8703 21.1791C13.9603 21.556 12.985 21.75 12.0001 21.75C7.85826 21.75 6.30482 19.755 3.25138 13.3125C3.00666 12.8821 2.94213 12.3723 3.07185 11.8945C3.20158 11.4167 3.51504 11.0096 3.94383 10.762C4.37262 10.5144 4.88193 10.4465 5.36061 10.5731C5.83928 10.6996 6.24848 11.0104 6.49888 11.4375L8.25013 14.25V5.625C8.25013 5.12772 8.44768 4.65081 8.79931 4.29917C9.15094 3.94754 9.62785 3.75 10.1251 3.75C10.6224 3.75 11.0993 3.94754 11.451 4.29917C11.8026 4.65081 12.0001 5.12772 12.0001 5.625",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M12 11.25V4.125C12 3.62772 12.1975 3.15081 12.5492 2.79917C12.9008 2.44754 13.3777 2.25 13.875 2.25C14.3723 2.25 14.8492 2.44754 15.2008 2.79917C15.5525 3.15081 15.75 3.62772 15.75 4.125V11.25",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), zi = $(Hi, _o), Ar = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s("path", { d: "M12 5.25V18.75", stroke: "currentColor", strokeWidth: "1.125", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M5.25 8.25V5.25H18.75V8.25",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s("path", { d: "M9 18.75H15", stroke: "currentColor", strokeWidth: "1.125", strokeLinecap: "round", strokeLinejoin: "round" })
] }), ji = $(Ar, ai), Vi = $(Ar, ci), yn = () => /* @__PURE__ */ s("div", { style: { width: "1px", height: "24px", background: _ } }), Ni = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s(
    "path",
    {
      d: "M7.5 15.75H3C2.80109 15.75 2.61032 15.671 2.46967 15.5303C2.32902 15.3897 2.25 15.1989 2.25 15V9C2.25 8.80109 2.32902 8.61032 2.46967 8.46967C2.61032 8.32902 2.80109 8.25 3 8.25H7.5L14.25 3V21L7.5 15.75Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s("path", { d: "M7.5 8.25V15.75", stroke: "currentColor", strokeWidth: "1.125", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M18 10.0171C18.4825 10.5649 18.7487 11.2699 18.7487 11.9999C18.7487 12.7299 18.4825 13.4349 18 13.9827",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M20.7815 7.5C21.8884 8.73755 22.5003 10.3397 22.5003 12C22.5003 13.6603 21.8884 15.2624 20.7815 16.5",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Or = $(Ni, ii), $i = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s(
    "path",
    {
      d: "M22.1028 9.35278C22.3225 9.13311 22.678 9.13311 22.8977 9.35278C23.1171 9.57248 23.1173 9.92813 22.8977 10.1477L21.0452 12.0002L22.8977 13.8528L22.97 13.9407C23.114 14.159 23.0898 14.4556 22.8977 14.6477C22.7056 14.8398 22.409 14.864 22.1907 14.72L22.1028 14.6477L20.2502 12.7952L18.3977 14.6477C18.1781 14.8673 17.8225 14.8671 17.6028 14.6477C17.3831 14.428 17.3831 14.0725 17.6028 13.8528L19.4553 12.0002L17.6028 10.1477C17.3831 9.92804 17.3831 9.57245 17.6028 9.35278C17.8225 9.13311 18.178 9.13311 18.3977 9.35278L20.2502 11.2053L22.1028 9.35278Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M13.9043 2.55591C14.0739 2.42401 14.3041 2.40097 14.4971 2.49536C14.69 2.58978 14.8125 2.78547 14.8125 3.00024V21.0002C14.8124 21.215 14.69 21.4107 14.4971 21.5051C14.3041 21.5995 14.0739 21.5764 13.9043 21.4446L7.30664 16.3127H3C2.65194 16.3127 2.3184 16.1741 2.07227 15.928C1.82616 15.6819 1.68754 15.3483 1.6875 15.0002V9.00024C1.6875 8.65218 1.82617 8.31864 2.07227 8.07251C2.31841 7.82637 2.6519 7.68774 3 7.68774H7.30664L13.9043 2.55591ZM8.06152 8.52661V15.4729L13.6875 19.8489V4.15063L8.06152 8.52661ZM3 8.81274C2.95027 8.81274 2.90235 8.83227 2.86719 8.86743C2.83207 8.90259 2.8125 8.95055 2.8125 9.00024V15.0002L2.82715 15.0715C2.83648 15.0941 2.84957 15.1154 2.86719 15.1331C2.90234 15.1682 2.9503 15.1877 3 15.1877H6.93652V8.81274H3Z",
      fill: "currentColor"
    }
  )
] }), _i = $($i, oi), Rr = ({
  onToggle: e,
  muted: t,
  size: n = "large",
  disabled: r
}) => {
  const o = n === "medium" ? 20 : 24, i = n === "medium" ? 14 : 18;
  return /* @__PURE__ */ s(Ce, { size: o, disabled: r, onClick: e, stopPropagation: !0, children: t ? /* @__PURE__ */ s(_i, { width: i, height: i }) : /* @__PURE__ */ s(Or, { width: i, height: i }) });
}, Ki = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s("path", { d: "M9.75 4.5L6 8.25L2.25 4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })
] }), rn = $(Ki, Vo);
function Xi({ text: e, children: t }) {
  return /* @__PURE__ */ s("span", { style: { fontSize: "0.875rem", fontWeight: 400 }, children: e ?? t });
}
function Zi({ text: e, children: t }) {
  return /* @__PURE__ */ s("span", { style: { fontSize: "0.75rem", fontWeight: 500 }, children: e ?? t });
}
function Gi({ text: e, children: t }) {
  return /* @__PURE__ */ s("span", { style: { fontSize: "0.625rem", fontWeight: 400, fontFamily: "'DM Mono', monospace" }, children: e ?? t });
}
const wn = 1.1;
function Yi({ label: e, shortcut: t, action: n, onClose: r }) {
  const o = te() ? {
    itemText: K,
    itemShortcut: ce,
    itemHoverBg: Lr,
    itemHoverText: Cr,
    itemHoverShortcut: Tr
  } : {
    itemText: K,
    itemShortcut: ce,
    itemHoverBg: _,
    itemHoverText: K,
    itemHoverShortcut: ce
  }, [i, c] = V(!1);
  return /* @__PURE__ */ s("div", { style: { padding: "0 4px" }, children: /* @__PURE__ */ D(
    "button",
    {
      className: "canvas-zoom-menu-item",
      style: {
        border: "none",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        padding: "4px 8px",
        borderRadius: 4,
        cursor: "pointer",
        background: i ? o.itemHoverBg : "transparent",
        color: i ? o.itemHoverText : o.itemText,
        fontSize: "0.75rem"
      },
      onMouseEnter: () => c(!0),
      onMouseLeave: () => c(!1),
      onClick: () => {
        n(), r();
      },
      children: [
        /* @__PURE__ */ s("span", { children: e }),
        /* @__PURE__ */ s("span", { style: { color: i ? o.itemHoverShortcut : o.itemShortcut }, children: `⌘ ${t}` })
      ]
    }
  ) });
}
function qi({ canvasZoom: e, onCanvasZoomChanged: t, onZoomToFit: n }) {
  const [r, o] = V(!1), i = W(null), c = br(), d = W(null), u = te() ? {
    surface: Sr
  } : {
    surface: fe
  };
  N(() => {
    if (!r) return;
    const b = (S) => {
      var g, v;
      (g = d.current) != null && g.contains(S.target) || (v = i.current) != null && v.contains(S.target) || o(!1);
    }, T = (S) => {
      S.key === "Escape" && (S.stopPropagation(), o(!1));
    };
    return document.addEventListener("mousedown", b), document.addEventListener("keydown", T, !0), () => {
      document.removeEventListener("mousedown", b), document.removeEventListener("keydown", T, !0);
    };
  }, [r]);
  const l = R(() => t(e * wn), [t, e]), f = R(() => t(e / wn), [t, e]), a = R(() => t(1), [t]), h = R(() => o(!1), []), p = [
    { label: "Zoom in", shortcut: "+", action: l },
    { label: "Zoom out", shortcut: "−", action: f },
    { label: "Zoom to 100%", shortcut: "0", action: a },
    { label: "Zoom to fit", shortcut: "1", action: n }
  ], [m, y] = V({ bottom: 0, right: 0 });
  return qt(() => {
    if (!r || !i.current) return;
    const b = i.current.getBoundingClientRect();
    y({ bottom: window.innerHeight - b.top + 4, right: window.innerWidth - b.right });
  }, [r]), /* @__PURE__ */ D(st, { children: [
    /* @__PURE__ */ D(
      "button",
      {
        ref: i,
        style: {
          display: "flex",
          alignItems: "center",
          boxSizing: "border-box",
          justifyContent: "space-between",
          padding: "4px 8px",
          borderRadius: 4,
          width: "78px",
          cursor: "pointer",
          color: K,
          background: r ? _ : "transparent",
          marginLeft: 8
        },
        onClick: (b) => {
          b.stopPropagation(), o((T) => !T);
        },
        onMouseDown: (b) => b.stopPropagation(),
        children: [
          /* @__PURE__ */ s(Zi, { text: `${Math.max(1, Math.trunc(e * 100))}%` }),
          /* @__PURE__ */ s(rn, { style: { transform: r ? "rotate(180deg)" : void 0 } })
        ]
      }
    ),
    r && Jn(
      /* @__PURE__ */ s(
        "div",
        {
          ...c,
          ref: d,
          style: {
            position: "fixed",
            bottom: m.bottom,
            right: m.right,
            width: 180,
            background: u.surface,
            border: `1px solid ${nn}`,
            borderRadius: 8,
            padding: "4px 0",
            zIndex: 1e4
          },
          children: p.map((b) => /* @__PURE__ */ s(Yi, { ...b, onClose: h }, b.label))
        }
      ),
      document.body
    )
  ] });
}
function Qi(e, t) {
  return Math.round(Math.max(0, e) * t);
}
function Il(e, t) {
  return Math.max(0, e) / t;
}
function Ve(e, t) {
  const n = Qi(e, t), r = n % t, o = Math.floor(n / t), i = Math.floor(o / 60), c = o % 60;
  return { minutes: i, seconds: c, frames: r };
}
function xn(e, t) {
  const n = e.minutes * 60 + e.seconds + e.frames / t;
  return Math.round(n * t) / t;
}
function Sn(e, t, n) {
  switch (e) {
    case "minutes":
      return Math.max(0, t);
    case "seconds":
      return Math.max(0, Math.min(59, t));
    case "frames":
      return Math.max(0, Math.min(n - 1, t));
  }
}
const Pt = ["minutes", "seconds", "frames"];
function Ui(e) {
  return String(Math.floor(e)).padStart(2, "0");
}
function Ln(e, t) {
  return Math.max(0, Math.min(e, t));
}
function Ji() {
  const e = I((l) => l.currentTime), t = I((l) => l.frameRate), n = I(Ro), r = I((l) => l.setCurrentTime), o = I((l) => l.isPlaying), i = I((l) => l.setPlaying), { onSeek: c } = G(), d = R(
    (l) => {
      const f = r(l);
      c(f);
    },
    [r, c]
  ), u = R(() => {
    o && i(!1);
  }, [o, i]);
  return /* @__PURE__ */ s(
    ea,
    {
      value: e,
      duration: n,
      frameRate: t,
      onChange: d,
      onEditingStart: u
    }
  );
}
function ea({
  value: e,
  duration: t,
  frameRate: n,
  onChange: r,
  onEditingStart: o,
  style: i,
  unstyled: c = !1
}) {
  const [d, u] = V(!1), [l, f] = V(() => Ve(e, n)), a = W(null), h = W([null, null, null]), p = W(!1), m = Ve(e, n), y = d ? l : m, b = R(
    (L) => {
      const x = xn(L, n), C = Ln(x, t);
      f(Ve(C, n)), r(C);
    },
    [t, n, r]
  ), T = R(() => {
    const L = xn(l, n), x = Ln(L, t);
    r(x), u(!1);
  }, [t, l, n, r]), S = R(() => {
    f(Ve(e, n)), u(!1);
  }, [e, n]), g = R(() => {
    d || (f(Ve(e, n)), u(!0), o == null || o());
  }, [n, d, o, e]), v = R(
    (L) => {
      var C;
      const x = L.relatedTarget;
      if (!((C = a.current) != null && C.contains(x))) {
        if (p.current) {
          p.current = !1;
          return;
        }
        d && T();
      }
    },
    [d, T]
  ), M = R(
    (L, x) => {
      const C = parseInt(x, 10);
      if (isNaN(C)) return;
      const E = Sn(L, C, n);
      f((k) => ({ ...k, [L]: E }));
    },
    [n]
  ), w = (L, x) => {
    var k, A;
    const C = Pt[L], E = x.currentTarget;
    switch (x.key) {
      case "ArrowUp":
      case "ArrowDown": {
        x.preventDefault();
        const P = x.key === "ArrowUp" ? 1 : -1, O = Sn(C, l[C] + P, n), B = { ...l, [C]: O };
        f(B), b(B);
        break;
      }
      case "ArrowLeft": {
        E.selectionStart === 0 && E.selectionEnd === 0 && L > 0 && (x.preventDefault(), (k = h.current[L - 1]) == null || k.focus());
        break;
      }
      case "ArrowRight": {
        const P = E.value.length;
        E.selectionStart === P && E.selectionEnd === P && L < Pt.length - 1 && (x.preventDefault(), (A = h.current[L + 1]) == null || A.focus());
        break;
      }
      case "Enter":
        x.preventDefault(), T(), p.current = !0, E.blur();
        break;
      case "Escape":
        x.preventDefault(), S(), p.current = !0, E.blur();
        break;
    }
  };
  return N(() => {
    const L = h.current, x = (C) => C.target.select();
    return L.forEach((C) => C == null ? void 0 : C.addEventListener("focus", x)), () => L.forEach((C) => C == null ? void 0 : C.removeEventListener("focus", x));
  }, []), /* @__PURE__ */ s(
    "div",
    {
      className: "timecode-input",
      ref: a,
      onBlur: v,
      style: {
        display: "inline-flex",
        alignItems: "center",
        height: 24,
        fontSize: "0.75rem",
        border: c ? void 0 : `1px solid ${ui}`,
        borderRadius: 4,
        padding: c ? "0" : "0 8px",
        boxSizing: "border-box",
        transition: "border-color 0.15s",
        ...i
      },
      children: Pt.map((L, x) => /* @__PURE__ */ D(re, { children: [
        x > 0 && /* @__PURE__ */ s(
          "span",
          {
            style: {
              position: "relative",
              top: "-1px",
              color: c ? "inherit" : ce,
              pointerEvents: "none",
              userSelect: "none"
            },
            children: ":"
          }
        ),
        /* @__PURE__ */ s(
          "input",
          {
            ref: (C) => {
              h.current[x] = C;
            },
            className: "timecode-segment",
            type: "text",
            inputMode: "numeric",
            value: Ui(y[L]),
            onFocus: g,
            onMouseDown: (C) => {
              document.activeElement === C.currentTarget && C.preventDefault();
            },
            onSelect: (C) => {
              const E = C.currentTarget, k = (E.selectionEnd ?? 0) - (E.selectionStart ?? 0);
              k > 0 && k < E.value.length && E.select();
            },
            onChange: (C) => M(L, C.target.value),
            onKeyDown: (C) => w(x, C),
            "aria-label": L,
            autoComplete: "off",
            autoCorrect: "off",
            autoCapitalize: "off",
            "data-form-type": "other",
            spellCheck: !1,
            style: {
              width: "2ch",
              background: "transparent",
              border: "none",
              outline: "none",
              color: c ? "inherit" : ce,
              textAlign: "center",
              padding: "1px 0",
              borderRadius: 2,
              caretColor: "transparent",
              font: "inherit"
            }
          }
        )
      ] }, L))
    }
  );
}
const Cn = 180, Tn = 8, ta = 4;
function na({ shape: e, onSelect: t }) {
  var c;
  const n = te(), r = n ? {
    itemText: K,
    itemShortcut: ce,
    itemHoverBg: Lr,
    itemHoverText: Cr,
    itemHoverShortcut: Tr
  } : {
    itemText: K,
    itemShortcut: ce,
    itemHoverBg: _,
    itemHoverText: K,
    itemHoverShortcut: ce
  }, [o, i] = V(!1);
  return /* @__PURE__ */ s("div", { style: { padding: "0 4px" }, children: /* @__PURE__ */ D(
    re,
    {
      component: "button",
      className: "shapes-menu-item",
      style: {
        width: "100%",
        boxSizing: "border-box",
        gap: 8,
        padding: "4px 8px",
        border: "none",
        borderRadius: 4,
        cursor: "pointer",
        background: o ? r.itemHoverBg : "transparent",
        color: o ? r.itemHoverText : r.itemText,
        ...n ? { "--fpl-icon-color": o ? r.itemHoverText : r.itemText } : {},
        fontSize: "0.75rem"
      },
      onMouseEnter: () => i(!0),
      onMouseLeave: () => i(!1),
      onClick: t,
      children: [
        e.icon,
        /* @__PURE__ */ s("span", { style: { flex: 1, textAlign: "left" }, children: e.label }),
        (c = e.shortcut) != null && c.length ? /* @__PURE__ */ s("span", { style: { color: o ? r.itemHoverShortcut : r.itemShortcut }, children: e.shortcut.join("") }) : null
      ]
    }
  ) });
}
function ra({ shapes: e, activeShapeMode: t, size: n = 24, onOpen: r }) {
  const [o, i] = V(!1), [c, d] = V({ bottom: 0, left: 0 }), [u, l] = V(0), [f, a] = V(!1), [h, p] = V(!1), m = W(null), y = br(), b = W(null), T = te(), S = R(() => i(!1), []), g = T ? {
    surface: Sr
  } : {
    surface: fe
  }, v = e.findIndex((P) => P.value === t), M = v >= 0, w = v >= 0 ? v : u, L = e[w] ?? e[0];
  N(() => {
    if (!o) return;
    const P = (B) => {
      var F, H;
      (F = b.current) != null && F.contains(B.target) || (H = m.current) != null && H.contains(B.target) || i(!1);
    }, O = (B) => {
      B.key === "Escape" && (B.stopPropagation(), i(!1));
    };
    return document.addEventListener("mousedown", P), document.addEventListener("keydown", O, !0), () => {
      document.removeEventListener("mousedown", P), document.removeEventListener("keydown", O, !0);
    };
  }, [o]), qt(() => {
    if (!o) return;
    const P = () => {
      if (!m.current) return;
      const O = m.current.getBoundingClientRect(), B = window.innerWidth - Cn - Tn;
      d({
        bottom: window.innerHeight - O.top + ta,
        left: Math.max(Tn, Math.min(O.left, B))
      });
    };
    return P(), window.addEventListener("resize", P), () => window.removeEventListener("resize", P);
  }, [o]);
  let x = "transparent", C = T ? K : Xe;
  M && f || M ? (x = Fe, C = fe) : f && (x = _, C = K);
  const E = T ? { "--fpl-icon-color": C } : {}, k = T || h ? K : Xe, A = T ? { "--fpl-icon-color": k } : {};
  return /* @__PURE__ */ D(st, { children: [
    /* @__PURE__ */ s(Dr, { content: L == null ? void 0 : L.tooltip, children: /* @__PURE__ */ s(
      be,
      {
        component: "button",
        style: {
          width: n,
          height: n,
          borderRadius: 4,
          background: x,
          color: C,
          ...E
        },
        "aria-label": `Add ${L == null ? void 0 : L.label}`,
        onClick: (P) => {
          P.stopPropagation(), L == null || L.onSelect();
        },
        onMouseDown: (P) => P.stopPropagation(),
        onMouseEnter: () => a(!0),
        onMouseLeave: () => a(!1),
        children: L == null ? void 0 : L.iconLarge
      }
    ) }),
    /* @__PURE__ */ s(
      be,
      {
        ref: m,
        component: "button",
        style: {
          width: Math.round(n * 0.6),
          height: n,
          borderRadius: 4,
          background: o || h ? _ : "transparent",
          color: k,
          ...A
        },
        "aria-label": "Shapes menu",
        onClick: (P) => {
          P.stopPropagation(), i((O) => (O || r == null || r(), !O));
        },
        onMouseDown: (P) => P.stopPropagation(),
        onMouseEnter: () => p(!0),
        onMouseLeave: () => p(!1),
        children: /* @__PURE__ */ s(rn, {})
      }
    ),
    o && Jn(
      /* @__PURE__ */ s(
        "div",
        {
          ...y,
          ref: b,
          style: {
            position: "fixed",
            bottom: c.bottom,
            left: c.left,
            width: Cn,
            background: g.surface,
            border: `1px solid ${nn}`,
            borderRadius: 8,
            padding: "4px 0",
            zIndex: 1e4
          },
          children: e.map((P, O) => /* @__PURE__ */ s(
            na,
            {
              shape: P,
              onSelect: () => {
                l(O), P.onSelect(), S();
              }
            },
            P.value
          ))
        }
      ),
      document.body
    )
  ] });
}
const oa = j(ra);
function Pl({
  isMuted: e = !1,
  onToggleMute: t,
  canvasMode: n,
  onCanvasModeChange: r,
  canvasZoom: o,
  onCanvasZoomChanged: i,
  onZoomToFit: c,
  shapes: d,
  activeShapeMode: u,
  onShapesMenuOpen: l,
  onTextToolSelect: f,
  isTextToolActive: a = !1,
  onVectorToolSelect: h,
  isVectorToolActive: p = !1,
  vectorTooltip: m,
  selectTooltip: y,
  panTooltip: b,
  textTooltip: T,
  onHotkeyUsed: S
}) {
  const g = I((F) => F.isPlaying), v = I((F) => F.currentTime <= 0), M = I(Fo), w = I((F) => F.setPlaying), L = I((F) => F.setCurrentTime), x = I((F) => F.tracks.length > 0), { store: C, onSeek: E } = G(), k = R(() => {
    x && w(!g);
  }, [g, w, x]), A = R(
    (F) => {
      if (!x) return;
      g && w(!1);
      const { currentTime: H, duration: le, frameRate: Q } = C.getState(), ie = Math.round(H * Q), U = Math.max(0, Math.round(le * Q) - 1), we = Math.max(0, Math.min(ie + F, U)) / Q, Ie = L(we);
      E(Ie);
    },
    [g, w, L, x, C, E]
  ), P = R(() => {
    if (!x) return;
    g && w(!1);
    const F = L(0);
    E(F);
  }, [x, g, w, L, E]), O = R(() => {
    if (!x) return;
    g && w(!1);
    const { duration: F } = C.getState(), H = L(F);
    E(H);
  }, [x, g, w, L, C, E]);
  Si({ togglePlay: k, stepFrame: A, jumpToStart: P, jumpToEnd: O, onHotkeyUsed: S });
  const B = te() ? ft : fe;
  return /* @__PURE__ */ D(
    re,
    {
      className: "timeline-playback-controls",
      style: {
        height: "40px",
        padding: "0 8px",
        background: B,
        fontFamily: "'DM Sans', sans-serif"
      },
      children: [
        /* @__PURE__ */ s("div", { style: { flex: 1 } }),
        /* @__PURE__ */ D(be, { style: { gap: 8 }, children: [
          /* @__PURE__ */ s(Ce, { onClick: P, disabled: !x || v, ariaLabel: "Jump to start", children: /* @__PURE__ */ s(Ai, {}) }),
          /* @__PURE__ */ s(Ce, { onClick: () => A(-1), disabled: !x || v, ariaLabel: "Step back one frame", children: /* @__PURE__ */ s(Pi, {}) }),
          /* @__PURE__ */ s(Ce, { onClick: k, disabled: !x, ariaLabel: g ? "Pause" : "Play", children: g ? /* @__PURE__ */ s(Mi, { width: 20, height: 20 }) : /* @__PURE__ */ s(Ci, { width: 20, height: 20 }) }),
          /* @__PURE__ */ s(Ce, { onClick: () => A(1), disabled: !x || M, ariaLabel: "Step forward one frame", children: /* @__PURE__ */ s(Ei, {}) }),
          /* @__PURE__ */ s(Ce, { onClick: O, disabled: !x || M, ariaLabel: "Jump to end", children: /* @__PURE__ */ s(ki, {}) }),
          /* @__PURE__ */ s(Ji, {}),
          /* @__PURE__ */ s(yn, {}),
          t && /* @__PURE__ */ s(Rr, { onToggle: t, muted: e, disabled: !x })
        ] }),
        /* @__PURE__ */ D(re, { style: { flex: 1, justifyContent: "flex-end" }, children: [
          /* @__PURE__ */ D(re, { style: { gap: "4px", marginRight: "8px" }, children: [
            /* @__PURE__ */ s(
              It,
              {
                options: [
                  {
                    value: "select",
                    icon: /* @__PURE__ */ s(Wi, { width: 20, height: 20 }),
                    ariaLabel: "Select tool",
                    tooltip: y
                  },
                  {
                    value: "pan",
                    icon: /* @__PURE__ */ s(zi, { width: 20, height: 20 }),
                    ariaLabel: "Pan tool",
                    tooltip: b
                  }
                ],
                value: u || a || p ? null : n,
                onChange: r,
                size: 24
              }
            ),
            f ? /* @__PURE__ */ s(
              It,
              {
                options: [
                  {
                    value: "create-text",
                    icon: /* @__PURE__ */ s(Vi, { width: 20, height: 20 }),
                    ariaLabel: "Text tool",
                    tooltip: T
                  }
                ],
                value: a ? "create-text" : null,
                onChange: f,
                size: 24
              }
            ) : null,
            h ? /* @__PURE__ */ s(
              It,
              {
                options: [
                  {
                    value: "edit-vector",
                    icon: /* @__PURE__ */ s(Qo, {}),
                    ariaLabel: "Vector tool",
                    tooltip: m
                  }
                ],
                value: p ? "edit-vector" : null,
                onChange: h,
                size: 24
              }
            ) : null,
            d != null && d.length ? /* @__PURE__ */ s(oa, { shapes: d, activeShapeMode: u, onOpen: l }) : null
          ] }),
          /* @__PURE__ */ s(yn, {}),
          /* @__PURE__ */ s(qi, { canvasZoom: o, onCanvasZoomChanged: i, onZoomToFit: c })
        ] })
      ]
    }
  );
}
function ia(e) {
  if (Array.isArray(e)) return e;
}
function aa(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, c, d = [], u = !0, l = !1;
    try {
      if (i = (n = n.call(e)).next, t !== 0) for (; !(u = (r = i.call(n)).done) && (d.push(r.value), d.length !== t); u = !0) ;
    } catch (f) {
      l = !0, o = f;
    } finally {
      try {
        if (!u && n.return != null && (c = n.return(), Object(c) !== c)) return;
      } finally {
        if (l) throw o;
      }
    }
    return d;
  }
}
function Vt(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Fr(e, t) {
  if (e) {
    if (typeof e == "string") return Vt(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Vt(e, t) : void 0;
  }
}
function ca() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Br(e, t) {
  return ia(e) || aa(e, t) || Fr(e, t) || ca();
}
var kt = {}, Ne = {}, Mn;
function Wr() {
  if (Mn) return Ne;
  Mn = 1, Object.defineProperty(Ne, "__esModule", { value: !0 }), Ne.bind = void 0;
  function e(t, n) {
    var r = n.type, o = n.listener, i = n.options;
    return t.addEventListener(r, o, i), function() {
      t.removeEventListener(r, o, i);
    };
  }
  return Ne.bind = e, Ne;
}
var Ae = {}, En;
function la() {
  if (En) return Ae;
  En = 1;
  var e = Ae && Ae.__assign || function() {
    return e = Object.assign || function(i) {
      for (var c, d = 1, u = arguments.length; d < u; d++) {
        c = arguments[d];
        for (var l in c) Object.prototype.hasOwnProperty.call(c, l) && (i[l] = c[l]);
      }
      return i;
    }, e.apply(this, arguments);
  };
  Object.defineProperty(Ae, "__esModule", { value: !0 }), Ae.bindAll = void 0;
  var t = /* @__PURE__ */ Wr();
  function n(i) {
    if (!(typeof i > "u"))
      return typeof i == "boolean" ? {
        capture: i
      } : i;
  }
  function r(i, c) {
    if (c == null)
      return i;
    var d = e(e({}, i), { options: e(e({}, n(c)), n(i.options)) });
    return d;
  }
  function o(i, c, d) {
    var u = c.map(function(l) {
      var f = r(l, d);
      return (0, t.bind)(i, f);
    });
    return function() {
      u.forEach(function(f) {
        return f();
      });
    };
  }
  return Ae.bindAll = o, Ae;
}
var In;
function sa() {
  return In || (In = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.bindAll = e.bind = void 0;
    var t = /* @__PURE__ */ Wr();
    Object.defineProperty(e, "bind", { enumerable: !0, get: function() {
      return t.bind;
    } });
    var n = /* @__PURE__ */ la();
    Object.defineProperty(e, "bindAll", { enumerable: !0, get: function() {
      return n.bindAll;
    } });
  })(kt)), kt;
}
var Be = /* @__PURE__ */ sa(), Hr = "data-pdnd-honey-pot";
function zr(e) {
  return e instanceof Element && e.hasAttribute(Hr);
}
function on(e) {
  var t = document.elementsFromPoint(e.x, e.y), n = Br(t, 2), r = n[0], o = n[1];
  return r ? zr(r) ? o ?? null : r : null;
}
function Ge(e) {
  "@babel/helpers - typeof";
  return Ge = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ge(e);
}
function ua(e, t) {
  if (Ge(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Ge(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function da(e) {
  var t = ua(e, "string");
  return Ge(t) == "symbol" ? t : t + "";
}
function ve(e, t, n) {
  return (t = da(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var fa = 2147483647, pa = {
  inset: "unset",
  border: "none",
  padding: 0,
  margin: 0,
  overflow: "visible",
  color: "inherit",
  background: "transparent"
};
function ye(e) {
  var t = null;
  return function() {
    if (!t) {
      for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++)
        o[i] = arguments[i];
      var c = e.apply(this, o);
      t = {
        result: c
      };
    }
    return t.result;
  };
}
var Dt = ye(function() {
  return typeof HTMLElement < "u" && typeof HTMLElement.prototype.showPopover == "function";
});
function Pn(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function kn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pn(Object(n), !0).forEach(function(r) {
      ve(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pn(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Ye = 2, Dn = Ye / 2;
function ma(e) {
  return {
    x: Math.floor(e.x),
    y: Math.floor(e.y)
  };
}
function ha(e) {
  return {
    x: e.x - Dn,
    y: e.y - Dn
  };
}
function ga(e) {
  return {
    x: Math.max(e.x, 0),
    y: Math.max(e.y, 0)
  };
}
function va(e) {
  return {
    x: Math.min(e.x, window.innerWidth - Ye),
    y: Math.min(e.y, window.innerHeight - Ye)
  };
}
function An(e) {
  var t = e.client, n = va(ga(ha(ma(t))));
  return DOMRect.fromRect({
    x: n.x,
    y: n.y,
    width: Ye,
    height: Ye
  });
}
function On(e) {
  var t = e.clientRect;
  return {
    left: "".concat(t.left, "px"),
    top: "".concat(t.top, "px"),
    width: "".concat(t.width, "px"),
    height: "".concat(t.height, "px")
  };
}
function ba(e) {
  var t = e.client, n = e.clientRect;
  return (
    // is within horizontal bounds
    t.x >= n.x && t.x <= n.x + n.width && // is within vertical bounds
    t.y >= n.y && t.y <= n.y + n.height
  );
}
function ya(e) {
  var t = e.initial, n = document.createElement("div");
  n.setAttribute(Hr, "true"), Dt() && n.setAttribute("popover", "manual");
  var r = An({
    client: t
  });
  Object.assign(n.style, kn(kn({
    position: "fixed"
  }, Dt() ? (
    // needs to come first as it has 'inset: unset' which
    // needs to be overridden by our top / left values
    pa
  ) : {
    // Fallback: using maximum possible z-index so that this element
    // will always be on top of other positioned content.
    zIndex: fa
  }), {}, {
    // Setting a background color explicitly to avoid any inherited styles.
    // Looks like this could be `opacity: 0`, but worried that _might_
    // cause the element to be ignored on some platforms.
    // When debugging, set backgroundColor to something like "red".
    backgroundColor: "transparent",
    // Being explicit to avoid inheriting styles
    padding: 0,
    margin: 0,
    boxSizing: "border-box",
    // We want this element to absorb pointer events,
    // it's kind of the whole point 😉
    pointerEvents: "auto"
  }, On({
    clientRect: r
  }))), document.body.appendChild(n), Dt() && n.showPopover();
  var o = Be.bind(window, {
    type: "pointermove",
    listener: function(c) {
      var d = {
        x: c.clientX,
        y: c.clientY
      };
      r = An({
        client: d
      }), Object.assign(n.style, On({
        clientRect: r
      }));
    },
    // using capture so we are less likely to be impacted by event stopping
    options: {
      capture: !0
    }
  });
  return function(c) {
    var d = c.current;
    if (o(), ba({
      client: d,
      clientRect: r
    })) {
      n.remove();
      return;
    }
    function u() {
      l(), n.remove();
    }
    var l = Be.bindAll(window, [
      {
        type: "pointerdown",
        listener: u
      },
      {
        type: "pointermove",
        listener: u
      },
      {
        type: "focusin",
        listener: u
      },
      {
        type: "focusout",
        listener: u
      },
      // a 'pointerdown' should happen before 'dragstart', but just being super safe
      {
        type: "dragstart",
        listener: u
      },
      // if the user has dragged something out of the window
      // and then is dragging something back into the window
      // the first events we will see are "dragenter" (and then "dragover").
      // So if we see any of these we need to clear the post drag fix.
      {
        type: "dragenter",
        listener: u
      },
      {
        type: "dragover",
        listener: u
      }
      // Not adding a "wheel" event listener, as "wheel" by itself does not
      // resolve the bug.
    ], {
      // Using `capture` so less likely to be impacted by other code stopping events
      capture: !0
    });
  };
}
function wa() {
  var e = null;
  function t() {
    return e = null, Be.bind(window, {
      type: "pointermove",
      listener: function(o) {
        e = {
          x: o.clientX,
          y: o.clientY
        };
      },
      // listening for pointer move in capture phase
      // so we are less likely to be impacted by events being stopped.
      options: {
        capture: !0
      }
    });
  }
  function n() {
    var r = null;
    return function(i) {
      var c = i.eventName, d = i.payload;
      if (c === "onDragStart") {
        var u = d.location.initial.input, l = e ?? {
          x: u.clientX,
          y: u.clientY
        };
        r = ya({
          initial: l
        });
      }
      if (c === "onDrop") {
        var f, a = d.location.current.input;
        (f = r) === null || f === void 0 || f({
          current: {
            x: a.clientX,
            y: a.clientY
          }
        }), r = null, e = null;
      }
    };
  }
  return {
    bindEvents: t,
    getOnPostDispatch: n
  };
}
function xa(e) {
  if (Array.isArray(e)) return Vt(e);
}
function Sa(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function La() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jr(e) {
  return xa(e) || Sa(e) || Fr(e) || La();
}
var Ca = ye(function() {
  return process.env.NODE_ENV === "test" ? !1 : navigator.userAgent.includes("Firefox");
}), an = ye(function() {
  if (process.env.NODE_ENV === "test")
    return !1;
  var t = navigator, n = t.userAgent;
  return n.includes("AppleWebKit") && !n.includes("Chrome");
}), Nt = {
  isLeavingWindow: /* @__PURE__ */ Symbol("leaving"),
  isEnteringWindow: /* @__PURE__ */ Symbol("entering")
};
function Ta(e) {
  var t = e.dragLeave;
  return an() ? t.hasOwnProperty(Nt.isLeavingWindow) : !1;
}
(function() {
  if (typeof window > "u" || process.env.NODE_ENV === "test" || !an())
    return;
  function t() {
    return {
      enterCount: 0,
      isOverWindow: !1
    };
  }
  var n = t();
  function r() {
    n = t();
  }
  Be.bindAll(
    window,
    [{
      type: "dragstart",
      listener: function() {
        n.enterCount = 0, n.isOverWindow = !0;
      }
    }, {
      type: "drop",
      listener: r
    }, {
      type: "dragend",
      listener: r
    }, {
      type: "dragenter",
      listener: function(i) {
        !n.isOverWindow && n.enterCount === 0 && (i[Nt.isEnteringWindow] = !0), n.isOverWindow = !0, n.enterCount++;
      }
    }, {
      type: "dragleave",
      listener: function(i) {
        n.enterCount--, n.isOverWindow && n.enterCount === 0 && (i[Nt.isLeavingWindow] = !0, n.isOverWindow = !1);
      }
    }],
    // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
      capture: !0
    }
  );
})();
function Ma(e) {
  return "nodeName" in e;
}
function Ea(e) {
  return Ma(e) && e.ownerDocument !== document;
}
function Ia(e) {
  var t = e.dragLeave, n = t.type, r = t.relatedTarget;
  return n !== "dragleave" ? !1 : an() ? Ta({
    dragLeave: t
  }) : r == null ? !0 : Ca() ? Ea(r) : r instanceof HTMLIFrameElement;
}
function Pa(e) {
  var t = e.onDragEnd;
  return [
    // ## Detecting drag ending for removed draggables
    //
    // If a draggable element is removed during a drag and the user drops:
    // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
    // 2. if not over a valid drop target (or cancelled): we get nothing
    // The "dragend" event will not fire on the source draggable if it has been
    // removed from the DOM.
    // So we need to figure out if a drag operation has finished by looking at other events
    // We can do this by looking at other events
    // ### First detection: "pointermove" events
    // 1. "pointermove" events cannot fire during a drag and drop operation
    // according to the spec. So if we get a "pointermove" it means that
    // the drag and drop operations has finished. So if we get a "pointermove"
    // we know that the drag is over
    // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
    // other pointer events. However, firefox will allow a few
    // pointer event to get through after a drag starts.
    // The most I've seen is 3
    {
      type: "pointermove",
      listener: /* @__PURE__ */ (function() {
        var n = 0;
        return function() {
          if (n < 20) {
            n++;
            return;
          }
          t();
        };
      })()
    },
    // ### Second detection: "pointerdown" events
    // If we receive this event then we know that a drag operation has finished
    // and potentially another one is about to start.
    // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
    {
      type: "pointerdown",
      listener: t
    }
  ];
}
function $e(e) {
  return {
    altKey: e.altKey,
    button: e.button,
    buttons: e.buttons,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey,
    shiftKey: e.shiftKey,
    clientX: e.clientX,
    clientY: e.clientY,
    pageX: e.pageX,
    pageY: e.pageY
  };
}
var ka = function(t) {
  var n = [], r = null, o = function() {
    for (var c = arguments.length, d = new Array(c), u = 0; u < c; u++)
      d[u] = arguments[u];
    n = d, !r && (r = requestAnimationFrame(function() {
      r = null, t.apply(void 0, n);
    }));
  };
  return o.cancel = function() {
    r && (cancelAnimationFrame(r), r = null);
  }, o;
}, At = ka(function(e) {
  return e();
}), tt = /* @__PURE__ */ (function() {
  var e = null;
  function t(r) {
    var o = requestAnimationFrame(function() {
      e = null, r();
    });
    e = {
      frameId: o,
      fn: r
    };
  }
  function n() {
    e && (cancelAnimationFrame(e.frameId), e.fn(), e = null);
  }
  return {
    schedule: t,
    flush: n
  };
})();
function Da(e) {
  var t = e.source, n = e.initial, r = e.dispatchEvent, o = {
    dropTargets: []
  };
  function i(d) {
    r(d), o = {
      dropTargets: d.payload.location.current.dropTargets
    };
  }
  var c = {
    start: function(u) {
      var l = u.nativeSetDragImage, f = {
        current: n,
        previous: o,
        initial: n
      };
      i({
        eventName: "onGenerateDragPreview",
        payload: {
          source: t,
          location: f,
          nativeSetDragImage: l
        }
      }), tt.schedule(function() {
        i({
          eventName: "onDragStart",
          payload: {
            source: t,
            location: f
          }
        });
      });
    },
    dragUpdate: function(u) {
      var l = u.current;
      tt.flush(), At.cancel(), i({
        eventName: "onDropTargetChange",
        payload: {
          source: t,
          location: {
            initial: n,
            previous: o,
            current: l
          }
        }
      });
    },
    drag: function(u) {
      var l = u.current;
      At(function() {
        tt.flush();
        var f = {
          initial: n,
          previous: o,
          current: l
        };
        i({
          eventName: "onDrag",
          payload: {
            source: t,
            location: f
          }
        });
      });
    },
    drop: function(u) {
      var l = u.current, f = u.updatedSourcePayload;
      tt.flush(), At.cancel(), i({
        eventName: "onDrop",
        payload: {
          source: f ?? t,
          location: {
            current: l,
            previous: o,
            initial: n
          }
        }
      });
    }
  };
  return c;
}
var $t = {
  isActive: !1
};
function Vr() {
  return !$t.isActive;
}
function Aa(e) {
  return e.dataTransfer ? e.dataTransfer.setDragImage.bind(e.dataTransfer) : null;
}
function Oa(e) {
  var t = e.current, n = e.next;
  if (t.length !== n.length)
    return !0;
  for (var r = 0; r < t.length; r++)
    if (t[r].element !== n[r].element)
      return !0;
  return !1;
}
function Ra(e) {
  var t = e.event, n = e.dragType, r = e.getDropTargetsOver, o = e.dispatchEvent;
  if (!Vr())
    return;
  var i = Fa({
    event: t,
    dragType: n,
    getDropTargetsOver: r
  });
  $t.isActive = !0;
  var c = {
    current: i
  };
  Ot({
    event: t,
    current: i.dropTargets
  });
  var d = Da({
    source: n.payload,
    dispatchEvent: o,
    initial: i
  });
  function u(p) {
    var m = Oa({
      current: c.current.dropTargets,
      next: p.dropTargets
    });
    c.current = p, m && d.dragUpdate({
      current: c.current
    });
  }
  function l(p) {
    var m = $e(p), y = zr(p.target) ? on({
      x: m.clientX,
      y: m.clientY
    }) : p.target, b = r({
      target: y,
      input: m,
      source: n.payload,
      current: c.current.dropTargets
    });
    b.length && (p.preventDefault(), Ot({
      event: p,
      current: b
    })), u({
      dropTargets: b,
      input: m
    });
  }
  function f() {
    c.current.dropTargets.length && u({
      dropTargets: [],
      input: c.current.input
    }), d.drop({
      current: c.current,
      updatedSourcePayload: null
    }), a();
  }
  function a() {
    $t.isActive = !1, h();
  }
  var h = Be.bindAll(
    window,
    [{
      // 👋 Note: we are repurposing the `dragover` event as our `drag` event
      // this is because firefox does not publish pointer coordinates during
      // a `drag` event, but does for every other type of drag event
      // `dragover` fires on all elements that are being dragged over
      // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
      // 🦊😤
      type: "dragover",
      listener: function(m) {
        l(m), d.drag({
          current: c.current
        });
      }
    }, {
      type: "dragenter",
      listener: l
    }, {
      type: "dragleave",
      listener: function(m) {
        Ia({
          dragLeave: m
        }) && (u({
          input: c.current.input,
          dropTargets: []
        }), n.startedFrom === "external" && f());
      }
    }, {
      // A "drop" can only happen if the browser allowed the drop
      type: "drop",
      listener: function(m) {
        if (c.current = {
          dropTargets: c.current.dropTargets,
          input: $e(m)
        }, !c.current.dropTargets.length) {
          f();
          return;
        }
        m.preventDefault(), Ot({
          event: m,
          current: c.current.dropTargets
        }), d.drop({
          current: c.current,
          // When dropping something native, we need to extract the latest
          // `.items` from the "drop" event as it is now accessible
          updatedSourcePayload: n.type === "external" ? n.getDropPayload(m) : null
        }), a();
      }
    }, {
      // "dragend" fires when on the drag source (eg a draggable element)
      // when the drag is finished.
      // "dragend" will fire after "drop" (if there was a successful drop)
      // "dragend" does not fire if the draggable source has been removed during the drag
      // or for external drag sources (eg files)
      // This "dragend" listener will not fire if there was a successful drop
      // as we will have already removed the event listener
      type: "dragend",
      listener: function(m) {
        c.current = {
          dropTargets: c.current.dropTargets,
          input: $e(m)
        }, f();
      }
    }].concat(jr(Pa({
      onDragEnd: f
    }))),
    // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
      capture: !0
    }
  );
  d.start({
    nativeSetDragImage: Aa(t)
  });
}
function Ot(e) {
  var t, n = e.event, r = e.current, o = (t = r[0]) === null || t === void 0 ? void 0 : t.dropEffect;
  o != null && n.dataTransfer && (n.dataTransfer.dropEffect = o);
}
function Fa(e) {
  var t = e.event, n = e.dragType, r = e.getDropTargetsOver, o = $e(t);
  if (n.startedFrom === "external")
    return {
      input: o,
      dropTargets: []
    };
  var i = r({
    input: o,
    source: n.payload,
    target: t.target,
    current: []
  });
  return {
    input: o,
    dropTargets: i
  };
}
var Rn = {
  canStart: Vr,
  start: Ra
}, _t = /* @__PURE__ */ new Map();
function Ba(e) {
  var t = e.typeKey, n = e.mount, r = _t.get(t);
  if (r)
    return r.usageCount++, r;
  var o = {
    typeKey: t,
    unmount: n(),
    usageCount: 1
  };
  return _t.set(t, o), o;
}
function Wa(e) {
  var t = Ba(e);
  return function() {
    t.usageCount--, !(t.usageCount > 0) && (t.unmount(), _t.delete(e.typeKey));
  };
}
function mt() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function() {
    t.forEach(function(o) {
      return o();
    });
  };
}
function Nr(e, t) {
  var n = t.attribute, r = t.value;
  return e.setAttribute(n, r), function() {
    return e.removeAttribute(n);
  };
}
function Fn(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Se(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Fn(Object(n), !0).forEach(function(r) {
      ve(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Fn(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Rt(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = Ha(e)) || t) {
      n && (e = n);
      var r = 0, o = function() {
      };
      return { s: o, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(l) {
        throw l;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, c = !0, d = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var l = n.next();
    return c = l.done, l;
  }, e: function(l) {
    d = !0, i = l;
  }, f: function() {
    try {
      c || n.return == null || n.return();
    } finally {
      if (d) throw i;
    }
  } };
}
function Ha(e, t) {
  if (e) {
    if (typeof e == "string") return Bn(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Bn(e, t) : void 0;
  }
}
function Bn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Ft(e) {
  return e.slice(0).reverse();
}
function za(e) {
  var t = e.typeKey, n = e.defaultDropEffect, r = /* @__PURE__ */ new WeakMap(), o = "data-drop-target-for-".concat(t), i = "[".concat(o, "]");
  function c(p) {
    return r.set(p.element, p), function() {
      return r.delete(p.element);
    };
  }
  function d(p) {
    if (process.env.NODE_ENV !== "production") {
      var m = r.get(p.element);
      m && console.warn("You have already registered a [".concat(t, "] dropTarget on the same element"), {
        existing: m,
        proposed: p
      }), p.element instanceof HTMLIFrameElement && console.warn(`
            We recommend not registering <iframe> elements as drop targets
            as it can result in some strange browser event ordering.
          `.replace(/\s{2,}/g, " ").trim());
    }
    var y = mt(Nr(p.element, {
      attribute: o,
      value: "true"
    }), c(p));
    return ye(y);
  }
  function u(p) {
    var m, y, b, T, S = p.source, g = p.target, v = p.input, M = p.result, w = M === void 0 ? [] : M;
    if (g == null)
      return w;
    if (!(g instanceof Element))
      return g instanceof Node ? u({
        source: S,
        target: g.parentElement,
        input: v,
        result: w
      }) : w;
    var L = g.closest(i);
    if (L == null)
      return w;
    var x = r.get(L);
    if (x == null)
      return w;
    var C = {
      input: v,
      source: S,
      element: x.element
    };
    if (x.canDrop && !x.canDrop(C))
      return u({
        source: S,
        target: x.element.parentElement,
        input: v,
        result: w
      });
    var E = (m = (y = x.getData) === null || y === void 0 ? void 0 : y.call(x, C)) !== null && m !== void 0 ? m : {}, k = (b = (T = x.getDropEffect) === null || T === void 0 ? void 0 : T.call(x, C)) !== null && b !== void 0 ? b : n, A = {
      data: E,
      element: x.element,
      dropEffect: k,
      // we are collecting _actual_ drop targets, so these are
      // being applied _not_ due to stickiness
      isActiveDueToStickiness: !1
    };
    return u({
      source: S,
      target: x.element.parentElement,
      input: v,
      // Using bubble ordering. Same ordering as `event.getPath()`
      result: [].concat(jr(w), [A])
    });
  }
  function l(p) {
    var m = p.eventName, y = p.payload, b = Rt(y.location.current.dropTargets), T;
    try {
      for (b.s(); !(T = b.n()).done; ) {
        var S, g = T.value, v = r.get(g.element), M = Se(Se({}, y), {}, {
          self: g
        });
        v == null || (S = v[m]) === null || S === void 0 || S.call(
          v,
          // I cannot seem to get the types right here.
          // TS doesn't seem to like that one event can need `nativeSetDragImage`
          // @ts-expect-error
          M
        );
      }
    } catch (w) {
      b.e(w);
    } finally {
      b.f();
    }
  }
  var f = {
    onGenerateDragPreview: l,
    onDrag: l,
    onDragStart: l,
    onDrop: l,
    onDropTargetChange: function(m) {
      var y = m.payload, b = new Set(y.location.current.dropTargets.map(function(H) {
        return H.element;
      })), T = /* @__PURE__ */ new Set(), S = Rt(y.location.previous.dropTargets), g;
      try {
        for (S.s(); !(g = S.n()).done; ) {
          var v, M = g.value;
          T.add(M.element);
          var w = r.get(M.element), L = b.has(M.element), x = Se(Se({}, y), {}, {
            self: M
          });
          if (w == null || (v = w.onDropTargetChange) === null || v === void 0 || v.call(w, x), !L) {
            var C;
            w == null || (C = w.onDragLeave) === null || C === void 0 || C.call(w, x);
          }
        }
      } catch (H) {
        S.e(H);
      } finally {
        S.f();
      }
      var E = Rt(y.location.current.dropTargets), k;
      try {
        for (E.s(); !(k = E.n()).done; ) {
          var A, P, O = k.value;
          if (!T.has(O.element)) {
            var B = Se(Se({}, y), {}, {
              self: O
            }), F = r.get(O.element);
            F == null || (A = F.onDropTargetChange) === null || A === void 0 || A.call(F, B), F == null || (P = F.onDragEnter) === null || P === void 0 || P.call(F, B);
          }
        }
      } catch (H) {
        E.e(H);
      } finally {
        E.f();
      }
    }
  };
  function a(p) {
    f[p.eventName](p);
  }
  function h(p) {
    var m = p.source, y = p.target, b = p.input, T = p.current, S = u({
      source: m,
      target: y,
      input: b
    });
    if (S.length >= T.length)
      return S;
    for (var g = Ft(T), v = Ft(S), M = [], w = 0; w < g.length; w++) {
      var L, x = g[w], C = v[w];
      if (C != null) {
        M.push(C);
        continue;
      }
      var E = M[w - 1], k = g[w - 1];
      if ((E == null ? void 0 : E.element) !== (k == null ? void 0 : k.element))
        break;
      var A = r.get(x.element);
      if (!A)
        break;
      var P = {
        input: b,
        source: m,
        element: A.element
      };
      if (A.canDrop && !A.canDrop(P) || !((L = A.getIsSticky) !== null && L !== void 0 && L.call(A, P)))
        break;
      M.push(Se(Se({}, x), {}, {
        // making it clear to consumers this drop target is active due to stickiness
        isActiveDueToStickiness: !0
      }));
    }
    return Ft(M);
  }
  return {
    dropTargetForConsumers: d,
    getIsOver: h,
    dispatchEvent: a
  };
}
function ja(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = Va(e)) || t) {
      n && (e = n);
      var r = 0, o = function() {
      };
      return { s: o, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(l) {
        throw l;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, c = !0, d = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var l = n.next();
    return c = l.done, l;
  }, e: function(l) {
    d = !0, i = l;
  }, f: function() {
    try {
      c || n.return == null || n.return();
    } finally {
      if (d) throw i;
    }
  } };
}
function Va(e, t) {
  if (e) {
    if (typeof e == "string") return Wn(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Wn(e, t) : void 0;
  }
}
function Wn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Hn(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Na(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hn(Object(n), !0).forEach(function(r) {
      ve(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Hn(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function $a() {
  var e = /* @__PURE__ */ new Set(), t = null;
  function n(i) {
    t && (!i.canMonitor || i.canMonitor(t.canMonitorArgs)) && t.active.add(i);
  }
  function r(i) {
    var c = Na({}, i);
    e.add(c), n(c);
    function d() {
      e.delete(c), t && t.active.delete(c);
    }
    return ye(d);
  }
  function o(i) {
    var c = i.eventName, d = i.payload;
    if (c === "onGenerateDragPreview") {
      t = {
        canMonitorArgs: {
          initial: d.location.initial,
          source: d.source
        },
        active: /* @__PURE__ */ new Set()
      };
      var u = ja(e), l;
      try {
        for (u.s(); !(l = u.n()).done; ) {
          var f = l.value;
          n(f);
        }
      } catch (b) {
        u.e(b);
      } finally {
        u.f();
      }
    }
    if (t) {
      for (var a = Array.from(t.active), h = 0, p = a; h < p.length; h++) {
        var m = p[h];
        if (t.active.has(m)) {
          var y;
          (y = m[c]) === null || y === void 0 || y.call(m, d);
        }
      }
      c === "onDrop" && (t.active.clear(), t = null);
    }
  }
  return {
    dispatchEvent: o,
    monitorForConsumers: r
  };
}
function _a(e) {
  var t = e.typeKey, n = e.mount, r = e.dispatchEventToSource, o = e.onPostDispatch, i = e.defaultDropEffect, c = $a(), d = za({
    typeKey: t,
    defaultDropEffect: i
  });
  function u(a) {
    r == null || r(a), d.dispatchEvent(a), c.dispatchEvent(a), o == null || o(a);
  }
  function l(a) {
    var h = a.event, p = a.dragType;
    Rn.start({
      event: h,
      dragType: p,
      getDropTargetsOver: d.getIsOver,
      dispatchEvent: u
    });
  }
  function f() {
    function a() {
      var h = {
        canStart: Rn.canStart,
        start: l
      };
      return n(h);
    }
    return Wa({
      typeKey: t,
      mount: a
    });
  }
  return {
    registerUsage: f,
    dropTarget: d.dropTargetForConsumers,
    monitor: c.monitorForConsumers
  };
}
var Ka = ye(function() {
  return navigator.userAgent.toLocaleLowerCase().includes("android");
}), Xa = "pdnd:android-fallback", zn = "text/plain", Za = "text/uri-list", Ga = "application/vnd.pdnd", qe = /* @__PURE__ */ new WeakMap();
function Ya(e) {
  return qe.set(e.element, e), function() {
    qe.delete(e.element);
  };
}
var jn = wa(), cn = _a({
  typeKey: "element",
  defaultDropEffect: "move",
  mount: function(t) {
    return mt(jn.bindEvents(), Be.bind(document, {
      type: "dragstart",
      listener: function(r) {
        var o, i, c, d, u, l;
        if (t.canStart(r) && !r.defaultPrevented) {
          if (!r.dataTransfer) {
            process.env.NODE_ENV !== "production" && console.warn(`
              It appears as though you have are not testing DragEvents correctly.

              - If you are unit testing, ensure you have polyfilled DragEvent.
              - If you are browser testing, ensure you are dispatching drag events correctly.

              Please see our testing guides for more information:
              https://atlassian.design/components/pragmatic-drag-and-drop/core-package/testing
            `.replace(/ {2}/g, ""));
            return;
          }
          var f = r.target;
          if (f instanceof HTMLElement) {
            var a = qe.get(f);
            if (a) {
              var h = $e(r), p = {
                element: a.element,
                dragHandle: (o = a.dragHandle) !== null && o !== void 0 ? o : null,
                input: h
              };
              if (a.canDrag && !a.canDrag(p)) {
                r.preventDefault();
                return;
              }
              if (a.dragHandle) {
                var m = on({
                  x: h.clientX,
                  y: h.clientY
                });
                if (!a.dragHandle.contains(m)) {
                  r.preventDefault();
                  return;
                }
              }
              var y = (i = (c = a.getInitialDataForExternal) === null || c === void 0 ? void 0 : c.call(a, p)) !== null && i !== void 0 ? i : null;
              if (y)
                for (var b = 0, T = Object.entries(y); b < T.length; b++) {
                  var S = Br(T[b], 2), g = S[0], v = S[1];
                  r.dataTransfer.setData(g, v ?? "");
                }
              Ka() && !r.dataTransfer.types.includes(zn) && !r.dataTransfer.types.includes(Za) && r.dataTransfer.setData(zn, Xa), r.dataTransfer.setData(Ga, "");
              var M = {
                element: a.element,
                dragHandle: (d = a.dragHandle) !== null && d !== void 0 ? d : null,
                data: (u = (l = a.getInitialData) === null || l === void 0 ? void 0 : l.call(a, p)) !== null && u !== void 0 ? u : {}
              }, w = {
                type: "element",
                payload: M,
                startedFrom: "internal"
              };
              t.start({
                event: r,
                dragType: w
              });
            }
          }
        }
      }
    }));
  },
  dispatchEventToSource: function(t) {
    var n, r, o = t.eventName, i = t.payload;
    (n = qe.get(i.source.element)) === null || n === void 0 || (r = n[o]) === null || r === void 0 || r.call(
      n,
      // I cannot seem to get the types right here.
      // TS doesn't seem to like that one event can need `nativeSetDragImage`
      // @ts-expect-error
      i
    );
  },
  onPostDispatch: jn.getOnPostDispatch()
}), qa = cn.dropTarget, $r = cn.monitor;
function Qa(e) {
  if (process.env.NODE_ENV !== "production" && e.dragHandle && !e.element.contains(e.dragHandle) && console.warn("Drag handle element must be contained in draggable element", {
    element: e.element,
    dragHandle: e.dragHandle
  }), process.env.NODE_ENV !== "production") {
    var t = qe.get(e.element);
    t && console.warn("You have already registered a `draggable` on the same element", {
      existing: t,
      proposed: e
    });
  }
  var n = mt(
    // making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    cn.registerUsage(),
    Ya(e),
    Nr(e.element, {
      attribute: "draggable",
      value: "true"
    })
  );
  return ye(n);
}
var Qe = /* @__PURE__ */ new Map(), it = /* @__PURE__ */ new Set();
function _r(e) {
  Ua(e);
  var t = Qe.get(e);
  if (t)
    return t;
  var n = {
    timeOfEngagementStart: Date.now()
  };
  return Qe.set(e, n), n;
}
function Ua(e) {
  it.add(e);
}
function Ja(e) {
  it.clear(), e(), Qe.forEach(function(t, n) {
    it.has(n) || Qe.delete(n);
  }), it.clear();
}
function ec() {
  Qe.clear();
}
var Vn = /* @__PURE__ */ new Map();
function tc(e) {
  var t = Vn.get(e);
  if (t)
    return t;
  var n = nc(e);
  return Vn.set(e, n), n;
}
function nc(e) {
  var t = {
    type: "idle"
  }, n = [];
  function r(u) {
    if (t.type === "running") {
      var l = u - t.timeLastFrameFinished, f = t, a = f.latestArgs, h = on({
        x: a.location.current.input.clientX,
        y: a.location.current.input.clientY
      });
      Ja(function() {
        n.forEach(function(p) {
          return p({
            underUsersPointer: h,
            latestArgs: a,
            timeSinceLastFrame: l
          });
        });
      }), t.timeLastFrameFinished = u, t.frameId = requestAnimationFrame(r);
    }
  }
  function o() {
    t.type !== "idle" && (cancelAnimationFrame(t.frameId), ec(), t = {
      type: "idle"
    });
  }
  function i(u) {
    t.type === "idle" && (t = {
      // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
      type: "initializing",
      latestArgs: u,
      frameId: requestAnimationFrame(function(l) {
        t.type === "initializing" && (t = {
          type: "running",
          timeLastFrameFinished: l,
          latestArgs: t.latestArgs,
          frameId: requestAnimationFrame(r)
        });
      })
    });
  }
  function c(u) {
    if (t.type === "idle") {
      i(u);
      return;
    }
    t.latestArgs = u;
  }
  e({
    onDragStart: i,
    onDropTargetChange: c,
    onDrag: c,
    onDrop: o
  });
  var d = {
    onFrame: function(l) {
      n.push(l);
    }
  };
  return d;
}
var Kt = "data-auto-scrollable", rc = "[".concat(Kt, '="true"]');
function oc(e) {
  return e.setAttribute(Kt, "true"), function() {
    return e.removeAttribute(Kt);
  };
}
function Nn(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $n(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Nn(Object(n), !0).forEach(function(r) {
      ve(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Nn(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var ic = {
  startHitboxAtPercentageRemainingOfElement: {
    top: 0.25,
    right: 0.25,
    bottom: 0.25,
    left: 0.25
  },
  maxScrollAtPercentageRemainingOfHitbox: {
    top: 0.5,
    right: 0.5,
    bottom: 0.5,
    left: 0.5
  },
  timeDampeningDurationMs: 400,
  // Too big and it's too easy to trigger auto scrolling
  // Too small and it's too hard 😅
  maxMainAxisHitboxSize: 180
}, ac = {
  // What the value would be if we were scrolling at 15px per frame at 60fps.
  // This is the default as it works well for most experiences.
  // In certain scenarios though it can feel a bit slow.
  standard: 900,
  // What the value would be if we were scrolling at 25px per frame at 60fps.
  // This is not the default as it feels too fast for a lot of experiences.
  fast: 1500
};
function Kr(e) {
  var t;
  return $n($n({}, ic), {}, {
    // only allowing limited control over the config at this stage
    maxPixelScrollPerSecond: ac[(t = e == null ? void 0 : e.maxScrollSpeed) !== null && t !== void 0 ? t : "standard"]
  });
}
var cc = {
  // Notes:
  //
  // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
  //    (and fractional units don't reach true integer maximum when zoomed in / out)
  // 🍎 Safari 16.5.2: no fractional units
  // 🦊 Firefox 115.0: no fractional units
  // we have some scroll we can move backwards into
  top: function(t) {
    return t.scrollTop > 0;
  },
  // We have some scroll we can move forward into
  right: function(t) {
    return Math.ceil(t.scrollLeft) + t.clientWidth < t.scrollWidth;
  },
  // We have some scroll we can move forwards into
  bottom: function(t) {
    return Math.ceil(t.scrollTop) + t.clientHeight < t.scrollHeight;
  },
  // we have some scroll we can move back into.
  left: function(t) {
    return t.scrollLeft > 0;
  }
}, lc = ["top", "right", "bottom", "left"], sc = {
  top: "vertical",
  right: "horizontal",
  bottom: "vertical",
  left: "horizontal"
}, _n = {
  start: "top",
  end: "bottom",
  point: "y",
  size: "height"
}, Kn = {
  start: "left",
  end: "right",
  point: "x",
  size: "width"
}, Xr = {
  vertical: {
    mainAxis: _n,
    crossAxis: Kn
  },
  horizontal: {
    mainAxis: Kn,
    crossAxis: _n
  }
}, ln = {
  top: "start",
  right: "end",
  bottom: "end",
  left: "start"
};
function nt(e) {
  var t = e.edge, n = e.axis;
  return function(o) {
    var i = o.clientRect, c = o.config, d = Xr[n], u = d.mainAxis, l = d.crossAxis, f = ln[t], a = Math.min(
      // scale the size of the hitbox down for smaller elements
      c.startHitboxAtPercentageRemainingOfElement[t] * i[u.size],
      // Don't let the hitbox grow too big for big elements
      c.maxMainAxisHitboxSize
    );
    return DOMRect.fromRect(ve(ve(ve(ve({}, u.point, f === "start" ? (
      // begin from the start edge and grow inwards
      i[u.point]
    ) : (
      // begin from inside the end edge and grow towards the end edge
      i[u.point] + i[u.size] - a
    )), l.point, i[l.point]), u.size, a), l.size, i[l.size]));
  };
}
var uc = {
  top: nt({
    axis: "vertical",
    edge: "top"
  }),
  right: nt({
    axis: "horizontal",
    edge: "right"
  }),
  bottom: nt({
    axis: "vertical",
    edge: "bottom"
  }),
  left: nt({
    axis: "horizontal",
    edge: "left"
  })
};
function Xt(e) {
  var t = e.startOfRange, n = e.endOfRange, r = e.value, o = t < n;
  if (!o || r < t)
    return 0;
  if (r > n)
    return 1;
  var i = n - t;
  return (r - t) / i;
}
function dc(e) {
  var t = e.timeSinceLastFrame, n = e.config, r = n.maxPixelScrollPerSecond / 1e3, o = Math.ceil(r * t), i = n.maxPixelScrollPerSecond / 60;
  return Math.min(o, i);
}
function fc(e) {
  var t = e.client, n = e.axis, r = e.edge, o = e.hitbox, i = e.config, c = Xr[n].mainAxis, d = ln[r], u = o[c.size] * i.maxScrollAtPercentageRemainingOfHitbox[r];
  if (d === "end")
    return Xt({
      startOfRange: o[c.start],
      endOfRange: o[c.end] - u,
      value: t[c.point]
    });
  var l = Xt({
    startOfRange: o[c.start] + u,
    endOfRange: o[c.end],
    value: t[c.point]
  });
  return 1 - l;
}
function rt(e) {
  var t = e.client, n = e.timeSinceLastFrame, r = e.engagement, o = e.axis, i = e.hitbox, c = e.edge, d = e.isDistanceDampeningEnabled, u = e.config, l = dc({
    timeSinceLastFrame: n,
    config: u
  }), f = d ? fc({
    client: t,
    edge: c,
    hitbox: i,
    axis: o,
    config: u
  }) : 1, a = Xt({
    startOfRange: r.timeOfEngagementStart,
    endOfRange: r.timeOfEngagementStart + u.timeDampeningDurationMs,
    value: Date.now()
  }), h = f * a, p = Math.max(l * h, 1), m = ln[c];
  return m === "end" ? p : -1 * p;
}
function pc(e, t) {
  return t === "all" || e === t;
}
function mc(e) {
  var t = e.client, n = e.clientRect;
  return (
    // is within horizontal bounds
    t.x >= n.x && t.x <= n.x + n.width && // is within vertical bounds
    t.y >= n.y && t.y <= n.y + n.height
  );
}
function hc(e) {
  return e.getBoundingClientRect();
}
function Zr(e) {
  var t = e.element, n = e.input, r = e.timeSinceLastFrame, o = e.engagement, i = e.config, c = e.allowedAxis, d = e.getRect, u = d === void 0 ? hc : d, l = {
    x: n.clientX,
    y: n.clientY
  }, f = u(t), a = lc.reduce(function(m, y) {
    var b = uc[y]({
      clientRect: f,
      config: i
    }), T = sc[y];
    return !pc(T, c) || !mc({
      client: l,
      clientRect: b
    }) || !cc[y](t) || m.set(y, {
      edge: y,
      hitbox: b
    }), m;
  }, /* @__PURE__ */ new Map()), h = (function() {
    var m = "horizontal", y = a.get("left");
    if (y)
      return rt({
        client: l,
        edge: y.edge,
        hitbox: y.hitbox,
        axis: m,
        timeSinceLastFrame: r,
        engagement: o,
        isDistanceDampeningEnabled: !0,
        config: i
      });
    var b = a.get("right");
    return b ? rt({
      client: l,
      edge: b.edge,
      hitbox: b.hitbox,
      axis: m,
      timeSinceLastFrame: r,
      engagement: o,
      isDistanceDampeningEnabled: !0,
      config: i
    }) : 0;
  })(), p = (function() {
    var m = "vertical", y = a.get("bottom");
    if (y)
      return rt({
        client: l,
        edge: y.edge,
        hitbox: y.hitbox,
        axis: m,
        timeSinceLastFrame: r,
        engagement: o,
        isDistanceDampeningEnabled: !0,
        config: i
      });
    var b = a.get("top");
    return b ? rt({
      client: l,
      edge: b.edge,
      hitbox: b.hitbox,
      axis: m,
      timeSinceLastFrame: r,
      engagement: o,
      isDistanceDampeningEnabled: !0,
      config: i
    }) : 0;
  })();
  return {
    left: h,
    top: p
  };
}
function gc(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = vc(e)) || t) {
      n && (e = n);
      var r = 0, o = function() {
      };
      return { s: o, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(l) {
        throw l;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, c = !0, d = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var l = n.next();
    return c = l.done, l;
  }, e: function(l) {
    d = !0, i = l;
  }, f: function() {
    try {
      c || n.return == null || n.return();
    } finally {
      if (d) throw i;
    }
  } };
}
function vc(e, t) {
  if (e) {
    if (typeof e == "string") return Xn(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Xn(e, t) : void 0;
  }
}
function Xn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Gr(e) {
  return !!(e.top || e.left);
}
function Yr(e) {
  var t, n, r, o = e.target, i = e.input, c = e.source, d = e.findEntry, u = e.timeSinceLastFrame, l = e.available, f = l === void 0 ? {
    top: !0,
    left: !0
  } : l;
  if (!Gr(f) || !o)
    return f;
  var a = o.closest(rc);
  if (!a)
    return f;
  var h = d(a);
  if (!h)
    return f;
  function p() {
    var v;
    return Yr({
      target: (v = a == null ? void 0 : a.parentElement) !== null && v !== void 0 ? v : null,
      findEntry: d,
      source: c,
      timeSinceLastFrame: u,
      input: i,
      available: f
    });
  }
  var m = {
    input: i,
    source: c,
    element: a
  };
  if (h.canScroll && !h.canScroll(m))
    return p();
  var y = _r(a), b = Kr((t = h.getConfiguration) === null || t === void 0 ? void 0 : t.call(h, m)), T = (n = (r = h.getAllowedAxis) === null || r === void 0 ? void 0 : r.call(h, m)) !== null && n !== void 0 ? n : "all", S = Zr({
    element: a,
    engagement: y,
    input: i,
    timeSinceLastFrame: u,
    allowedAxis: T,
    config: b
  }), g = {
    top: 0,
    left: 0
  };
  return f.top && S.top !== 0 && (g.top = S.top, f.top = !1), f.left && S.left !== 0 && (g.left = S.left, f.left = !1), (g.top !== 0 || g.left !== 0) && a.scrollBy(g), p();
}
function bc(e) {
  var t = e.input, n = e.timeSinceLastFrame, r = e.available, o = e.source, i = e.entries, c = document.documentElement, d = {
    input: t,
    source: o,
    element: c
  }, u = gc(i), l;
  try {
    for (u.s(); !(l = u.n()).done; ) {
      var f, a, h, p = l.value;
      if (!(p.canScroll && !p.canScroll(d))) {
        var m = _r(c), y = Kr((f = p.getConfiguration) === null || f === void 0 ? void 0 : f.call(p, d)), b = (a = (h = p.getAllowedAxis) === null || h === void 0 ? void 0 : h.call(p, d)) !== null && a !== void 0 ? a : "all", T = Zr({
          element: c,
          engagement: m,
          input: t,
          config: y,
          allowedAxis: b,
          getRect: function(v) {
            return DOMRect.fromRect({
              y: 0,
              x: 0,
              width: v.clientWidth,
              height: v.clientHeight
            });
          },
          timeSinceLastFrame: n
        }), S = {
          top: r.top ? T.top : 0,
          left: r.left ? T.left : 0
        };
        (S.top !== 0 || S.left !== 0) && c.scrollBy(S);
        break;
      }
    }
  } catch (g) {
    u.e(g);
  } finally {
    u.f();
  }
}
function yc(e) {
  var t = e.input, n = e.findEntry, r = e.timeSinceLastFrame, o = e.source, i = e.getWindowScrollEntries, c = e.underUsersPointer, d = Yr({
    target: c,
    timeSinceLastFrame: r,
    input: t,
    source: o,
    findEntry: n
  });
  Gr(d) && bc({
    input: t,
    source: o,
    entries: i(),
    timeSinceLastFrame: r,
    available: d
  });
}
function Zn(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function wc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zn(Object(n), !0).forEach(function(r) {
      ve(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zn(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function xc(e) {
  var t = e.monitor, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set();
  function o(l) {
    if (process.env.NODE_ENV !== "production") {
      var f = window.getComputedStyle(l.element), a = f.overflowX, h = f.overflowY, p = a === "auto" || a === "scroll" || h === "auto" || h === "scroll";
      p || console.warn("Auto scrolling has been attached to an element that appears not to be scrollable", {
        element: l.element,
        overflowX: a,
        overflowY: h
      });
    }
    if (process.env.NODE_ENV !== "production") {
      var m = n.get(l.element);
      m && console.warn("You have already registered autoScrolling on the same element", {
        existing: m,
        proposed: l
      });
    }
    n.set(l.element, l);
    var y = mt(oc(l.element), function() {
      return n.delete(l.element);
    });
    return ye(y);
  }
  function i() {
    var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, f = wc({}, l);
    r.add(f);
    function a() {
      r.delete(f);
    }
    return ye(a);
  }
  function c(l) {
    var f;
    return (f = n.get(l)) !== null && f !== void 0 ? f : null;
  }
  function d() {
    return Array.from(r);
  }
  function u(l) {
    var f = l.latestArgs, a = l.underUsersPointer, h = l.timeSinceLastFrame;
    yc({
      input: f.location.current.input,
      source: f.source,
      findEntry: c,
      underUsersPointer: a,
      timeSinceLastFrame: h,
      getWindowScrollEntries: d
    });
  }
  return tc(t).onFrame(u), {
    autoScroll: o,
    autoScrollWindow: i
  };
}
var Sc = xc({
  monitor: $r
}), Lc = Sc.autoScroll;
function Cc(e) {
  const { store: t } = G(), n = I((i) => i.setZoomLevel), r = I((i) => i.setScrollPosition), o = R(
    (i) => {
      if (!i.ctrlKey && !i.metaKey) return;
      i.preventDefault();
      const c = t.getState(), d = hr(c), u = gr(c), l = ct(c), f = lt(c), { currentTime: a, duration: h, zoomLevel: p, scrollPosition: m } = c;
      if (h === 0) return;
      const b = Math.pow(2, -i.deltaY * 5e-3), T = Math.min(u, p), S = p * b, g = Math.max(T, Math.min(S, d));
      if (g === p) return;
      const v = g / p, { newScroll: M } = lr(
        p,
        v,
        a,
        m,
        h,
        c.containerWidth,
        l,
        f
      );
      n(g), r(M);
    },
    [n, r, t]
  );
  N(() => {
    const i = e.current;
    if (i)
      return i.addEventListener("wheel", o, { passive: !1 }), () => {
        i.removeEventListener("wheel", o);
      };
  }, [e, o]);
}
function Tc(e) {
  const { store: t } = G(), n = R(
    (l) => {
      if (l.ctrlKey || l.metaKey || !l.shiftKey && Math.abs(l.deltaX) <= 0)
        return;
      const f = Math.abs(l.deltaX) > 0 ? l.deltaX : l.deltaY;
      l.preventDefault();
      const { scrollPosition: a, setScrollPosition: h } = t.getState(), p = oe(t.getState()), m = f / p;
      h(a + m);
    },
    [t]
  ), r = W(!1), o = W(0), i = W(0), c = R(
    (l) => {
      l.button === 1 && (l.preventDefault(), r.current = !0, o.current = l.clientX, i.current = t.getState().scrollPosition, document.body.style.cursor = "grabbing");
    },
    [t]
  ), d = R(
    (l) => {
      if (!r.current) return;
      const f = o.current - l.clientX, { setScrollPosition: a } = t.getState(), h = oe(t.getState()), p = f / h;
      a(i.current + p);
    },
    [t]
  ), u = R(() => {
    r.current && (r.current = !1, document.body.style.cursor = "");
  }, []);
  N(() => {
    const l = e.current;
    if (l)
      return l.addEventListener("wheel", n, { passive: !1 }), l.addEventListener("mousedown", c), document.addEventListener("mousemove", d), document.addEventListener("mouseup", u), () => {
        l.removeEventListener("wheel", n), l.removeEventListener("mousedown", c), document.removeEventListener("mousemove", d), document.removeEventListener("mouseup", u);
      };
  }, [e, n, c, d, u]);
}
function Mc(e, t) {
  N(() => {
    const n = e.current, r = t.current;
    if (!n || !r) return;
    const o = () => {
      r.scrollTop = n.scrollTop;
    }, i = () => {
      n.scrollTop = r.scrollTop;
    };
    return n.addEventListener("scroll", o), r.addEventListener("scroll", i), () => {
      n.removeEventListener("scroll", o), r.removeEventListener("scroll", i);
    };
  }, [e, t]);
}
function qr() {
  const e = I((c) => c.duration), t = I((c) => c.scrollPosition), n = I((c) => c.containerWidth), r = I(oe), o = n + 2 * Z, i = (c) => (c - t) * r + Z;
  return {
    active: e > 0,
    startX: Math.max(0, Math.min(i(0), o)),
    endX: Math.max(0, Math.min(i(e), o)),
    fullWidth: o
  };
}
function Ec(e, t, n, r, o) {
  const i = Math.round(e * o) / o;
  let c = i, d = r, u = null;
  for (const l of n) {
    const f = Math.abs(i - l);
    f < d && (d = f, c = l, u = l);
    const a = Math.abs(i + t - l);
    a < d && (d = a, c = l - t, u = l);
  }
  return { startTime: c, snapIndicator: u };
}
function Ic(e, t, n, r, o, i, c, d) {
  const u = 1 / d;
  let l = t + e, f = o;
  if (X(n) && (f = o - e, f < 0 && (l = t + o, f = 0)), l < u) {
    const y = u - l;
    l = u, X(n) && (f += y);
  }
  const a = r + l, { snappedEdge: h, snapIndicator: p } = sn(a, i, c), m = h - a;
  return m !== 0 && (l += m, X(n) && (f -= m), X(n) && f < 0 && (l += f, f = 0), l < u && (X(n) && (f += u - l), l = u)), l = Math.round(l * d) / d, X(n) && (f = t + o - l), { duration: l, trimEnd: f, snapIndicator: p };
}
function Pc(e, t, n, r, o, i, c, d) {
  const u = 1 / d;
  let l = r + e, f = t - e, a = o;
  if (X(n) && (a = o + e, a < 0 && (l = r - o, f = t + o, a = 0)), f < u) {
    const b = u - f;
    f = u, l -= b, X(n) && (a -= b), X(n) && a < 0 && (a = 0);
  }
  const h = l, { snappedEdge: p, snapIndicator: m } = sn(h, i, c), y = p - h;
  if (y !== 0 && (l += y, f -= y, X(n) && (a += y), X(n) && a < 0 && (l -= a, f += a, a = 0), f < u)) {
    const b = u - f;
    f = u, l -= b, X(n) && (a -= b), X(n) && a < 0 && (a = 0);
  }
  return l = Math.round(l * d) / d, f = r + t - l, X(n) && (a = o + t - f), { startTime: l, duration: f, trimStart: a, snapIndicator: m };
}
function Qr(e, t, n, r = []) {
  const o = new Set(t), i = [...r];
  for (const c of e)
    o.has(c.id) || i.push(c.startTime, Math.round((c.startTime + c.duration) * n) / n);
  return i;
}
function sn(e, t, n) {
  let r = e, o = n, i = null;
  for (const c of t) {
    const d = Math.abs(e - c);
    d < o && (o = d, r = c, i = c);
  }
  return { snappedEdge: r, snapIndicator: i };
}
const kc = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s(
    "path",
    {
      d: "M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M9 10.5C9.82843 10.5 10.5 9.82843 10.5 9C10.5 8.17157 9.82843 7.5 9 7.5C8.17157 7.5 7.5 8.17157 7.5 9C7.5 9.82843 8.17157 10.5 9 10.5Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M5.31494 20.2499L15.5946 9.96923C15.6643 9.8995 15.747 9.84418 15.838 9.80644C15.9291 9.76869 16.0267 9.74927 16.1253 9.74927C16.2238 9.74927 16.3214 9.76869 16.4125 9.80644C16.5035 9.84418 16.5862 9.8995 16.6559 9.96923L20.2503 13.5645",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Dc = $(kc, Xo), Ac = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s(
    "path",
    {
      d: "M14.8 12.5L10 9.5V15.5L14.8 12.5Z",
      stroke: "currentColor",
      strokeWidth: "1.13",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M20.1818 5H3.81818C3.36631 5 3 5.47969 3 6.07143V18.9286C3 19.5203 3.36631 20 3.81818 20H20.1818C20.6337 20 21 19.5203 21 18.9286V6.07143C21 5.47969 20.6337 5 20.1818 5Z",
      stroke: "currentColor",
      strokeWidth: "1.13",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Oc = $(Ac, li), Rc = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { width: "24", height: "24", viewBox: "56 56 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M65.7617 60.6361C65.7662 60.6473 65.771 60.6583 65.7761 60.6692C65.7829 60.6838 65.7903 60.6981 65.7983 60.712C65.8957 60.8832 66.0718 61 66.2719 61C66.5965 61 66.8407 60.7013 66.7365 60.394C66.2809 59.05 65.2694 57.9626 63.9758 57.4056C63.3698 57.1446 62.7018 57 62 57C59.2386 57 57 59.2386 57 62C57 62.7018 57.1446 63.3698 57.4056 63.9758C57.9626 65.2694 59.05 66.2809 60.394 66.7365C60.7013 66.8407 61 66.5965 61 66.2719C61 66.0718 60.8832 65.8957 60.712 65.7983C60.6981 65.7903 60.6838 65.7829 60.6692 65.7761C60.6583 65.771 60.6473 65.7662 60.6361 65.7617L60.6201 65.7556C59.6656 65.4048 58.8818 64.7004 58.4275 63.8012C58.1541 63.2599 58 62.6479 58 62C58 59.7909 59.7909 58 62 58C63.7242 58 65.1936 59.0909 65.7556 60.6201L65.7617 60.6361ZM63.5 63H69.5C69.7761 63 70 63.2239 70 63.5V69.5C70 69.7761 69.7761 70 69.5 70H63.5C63.2239 70 63 69.7761 63 69.5V63.5C63 63.2239 63.2239 63 63.5 63ZM62 63.5C62 62.6716 62.6716 62 63.5 62H69.5C70.3284 62 71 62.6716 71 63.5V69.5C71 70.3284 70.3284 71 69.5 71H63.5C62.6716 71 62 70.3284 62 69.5V63.5Z",
      fill: "currentColor"
    }
  )
] }), Fc = $(Rc, Jo), Bc = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s(
    "path",
    {
      d: "M12.4147 3.31802C12.1531 3.18913 11.8469 3.18913 11.5853 3.31802L3.84853 7.13003C3.49614 7.30368 3.49614 7.80624 3.84853 7.97989L11.5853 11.7919C11.8469 11.9208 12.1531 11.9208 12.4147 11.7919L20.1515 7.97989C20.5039 7.80624 20.5039 7.30368 20.1515 7.13003L12.4147 3.31802Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M3.75 12L11.5853 15.8612C11.8469 15.9901 12.1531 15.9901 12.4147 15.8612L20.25 12",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M3.75 16.5L11.5853 20.3612C11.8469 20.4901 12.1531 20.4901 12.4147 20.3612L20.25 16.5",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Wc = $(Bc, $o), Hc = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s(
    "path",
    {
      d: "M12 5.25C4.5 5.25 1.5 12 1.5 12C1.5 12 4.5 18.75 12 18.75C19.5 18.75 22.5 12 22.5 12C22.5 12 19.5 5.25 12 5.25Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), zc = $(Hc, No), jc = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s(
    "path",
    {
      d: "M3 9.75C4.57594 11.7009 7.46531 14.25 12 14.25C16.5347 14.25 19.4241 11.7009 21 9.75",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M21 15.7499L18.8081 11.9146",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M15.0001 17.9998L14.3354 14.0107",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M9 17.9998L9.66469 14.0107",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M3 15.7499L5.19187 11.9146",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Vc = $(jc, Ko), Nc = ({
  onToggle: e,
  hidden: t,
  disabled: n
}) => /* @__PURE__ */ s(Ce, { size: 20, disabled: n, onClick: e, stopPropagation: !0, children: t ? /* @__PURE__ */ s(Vc, { width: 14, height: 14 }) : /* @__PURE__ */ s(zc, { width: 14, height: 14 }) }), $c = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s(
    "path",
    {
      d: "M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M8.25 8.25V5.25C8.25 4.25544 8.64509 3.30161 9.34835 2.59835C10.0516 1.89509 11.0054 1.5 12 1.5C12.9946 1.5 13.9484 1.89509 14.6517 2.59835C15.3549 3.30161 15.75 4.25544 15.75 5.25V8.25",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), _c = $($c, Zo), Kc = ({ title: e, ...t }) => /* @__PURE__ */ D("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...t, children: [
  e ? /* @__PURE__ */ s("title", { children: e }) : null,
  /* @__PURE__ */ s(
    "path",
    {
      d: "M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ s(
    "path",
    {
      d: "M8.25 8.25V5.25C8.25 4.25544 8.64509 3.30161 9.34835 2.59835C10.0516 1.89509 11.0054 1.5 12 1.5C13.8141 1.5 15.4022 2.78812 15.75 4.5",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Xc = $(Kc, Go), Zc = ({
  onToggle: e,
  locked: t,
  disabled: n
}) => /* @__PURE__ */ s(Ce, { size: 20, disabled: n, onClick: e, stopPropagation: !0, children: t ? /* @__PURE__ */ s(_c, { width: 14, height: 14 }) : /* @__PURE__ */ s(Xc, { width: 14, height: 14 }) });
function Gc({
  value: e,
  onSubmit: t,
  noBorder: n,
  showHoverBackground: r = !0,
  maxWidth: o,
  onEditingChange: i,
  readOnly: c,
  style: d
}) {
  const [u, l] = V(!1), [f, a] = V(!1), h = W(null), p = R(
    (S) => {
      const g = S.trim();
      g !== "" && t(g);
    },
    [t]
  ), m = R(() => {
    l(!1), i == null || i(!1);
  }, [i]), y = R(() => {
    var g;
    const S = ((g = h.current) == null ? void 0 : g.textContent) ?? "";
    p(S), m();
  }, [p, m]), b = R(
    (S) => {
      var g;
      S.code === "Enter" ? (S.preventDefault(), p(((g = h.current) == null ? void 0 : g.textContent) ?? ""), m()) : S.code === "Escape" ? (S.preventDefault(), h.current && (h.current.textContent = e), m()) : S.code === "KeyZ" && (S.getModifierState("Control") || S.getModifierState("Meta")) ? (S.stopPropagation(), S.preventDefault()) : (S.code === "Backspace" || S.code === "Delete") && S.stopPropagation();
    },
    [p, m, e]
  ), T = R(() => {
    c || (l(!0), i == null || i(!0));
  }, [i, c]);
  return N(() => {
    if (u && h.current) {
      h.current.focus();
      const S = document.createRange();
      S.selectNodeContents(h.current);
      const g = window.getSelection();
      g == null || g.removeAllRanges(), g == null || g.addRange(S);
    }
  }, [u]), /* @__PURE__ */ s(
    "span",
    {
      ref: h,
      contentEditable: u,
      suppressContentEditableWarning: !0,
      onDoubleClick: T,
      onMouseEnter: () => a(!0),
      onMouseLeave: () => a(!1),
      onMouseDown: u ? (S) => S.stopPropagation() : void 0,
      onBlur: u ? y : void 0,
      onKeyDown: u ? b : void 0,
      style: {
        fontSize: "0.75rem",
        fontWeight: 400,
        cursor: u ? "text" : c ? "default" : "pointer",
        backgroundColor: !u && !c && r && f ? _ : void 0,
        borderRadius: "4px",
        padding: "2px 4px",
        outline: u && !n ? `1px solid ${ce}` : "none",
        display: "block",
        width: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: u ? "clip" : "ellipsis",
        minHeight: "1.2em",
        maxWidth: o,
        ...d
      },
      children: e
    },
    u ? "editing" : "display"
  );
}
function Yc() {
  const e = I((g) => g.zoomLevel), t = I(hr), n = I(gr), r = Math.min(n, e), o = I((g) => g.setZoomLevel), i = I((g) => g.scrollPosition), c = I((g) => g.currentTime), d = I((g) => g.duration), u = I(ct), l = I(lt), f = I((g) => g.containerWidth), a = I((g) => g.setScrollPosition), h = (g) => {
    const v = g / e, { newScroll: M } = lr(
      e,
      v,
      c,
      i,
      d,
      f,
      u,
      l
    );
    o(g), a(M);
  }, p = () => {
    h(Math.min(e * bn, t));
  }, m = () => {
    h(Math.max(e / bn, r));
  }, y = Math.log(r), b = Math.log(Math.max(t, r + Do)), T = (Math.log(e) - y) / (b - y), S = (g) => {
    const v = parseFloat(g.target.value), M = Math.exp(y + v * (b - y));
    h(M);
  };
  return /* @__PURE__ */ D(re, { style: { gap: 4, height: "100%", paddingRight: "8px" }, onMouseDown: (g) => g.stopPropagation(), children: [
    /* @__PURE__ */ s(
      be,
      {
        component: "button",
        className: "zoom-button",
        style: {
          width: 12,
          height: 12,
          flexShrink: 0,
          padding: 0,
          border: "none",
          borderRadius: "50%",
          background: "transparent",
          color: ce,
          cursor: "pointer"
        },
        onClick: m,
        disabled: e <= r,
        "aria-label": "Zoom out",
        children: /* @__PURE__ */ D("svg", { viewBox: "0 0 12 12", width: "12", height: "12", children: [
          /* @__PURE__ */ s("circle", { cx: "6", cy: "6", r: "5", fill: "none", stroke: "currentColor", strokeWidth: "1.2" }),
          /* @__PURE__ */ s("line", { x1: "3.5", y1: "6", x2: "8.5", y2: "6", stroke: "currentColor", strokeWidth: "1.2" })
        ] })
      }
    ),
    /* @__PURE__ */ s(
      "input",
      {
        className: "zoom-slider",
        type: "range",
        min: "0",
        max: "1",
        step: "0.001",
        value: T,
        onChange: S,
        "aria-label": "Zoom level",
        style: {
          WebkitAppearance: "none",
          appearance: "none",
          flex: 1,
          minWidth: 0,
          height: 6,
          borderRadius: 3,
          background: _,
          outline: "none",
          cursor: "pointer"
        }
      }
    ),
    /* @__PURE__ */ s(
      be,
      {
        component: "button",
        className: "zoom-button",
        style: {
          width: 12,
          height: 12,
          flexShrink: 0,
          padding: 0,
          border: "none",
          borderRadius: "50%",
          background: "transparent",
          color: ce,
          cursor: "pointer"
        },
        onClick: p,
        disabled: e >= t,
        "aria-label": "Zoom in",
        children: /* @__PURE__ */ D("svg", { viewBox: "0 0 12 12", width: "12", height: "12", children: [
          /* @__PURE__ */ s("circle", { cx: "6", cy: "6", r: "5", fill: "none", stroke: "currentColor", strokeWidth: "1.2" }),
          /* @__PURE__ */ s("line", { x1: "3.5", y1: "6", x2: "8.5", y2: "6", stroke: "currentColor", strokeWidth: "1.2" }),
          /* @__PURE__ */ s("line", { x1: "6", y1: "3.5", x2: "6", y2: "8.5", stroke: "currentColor", strokeWidth: "1.2" })
        ] })
      }
    )
  ] });
}
const qc = 4, Gn = fr * 2 + dr + qc - 2 * Z;
function Qc() {
  const e = I((v) => v.scrollPosition), t = I(jt), n = I(ct), r = I(lt), o = I((v) => v.containerWidth), i = I(zt), c = I(oe), d = I((v) => v.setScrollPosition), { store: u } = G(), l = W(null), f = Math.max(0, o - Gn), a = t > 0 ? i / t : 1, h = Math.max(vn, f * a), m = Math.max(n, at(r, i, c)) - n, y = m > 0 ? (e - n) / m * (f - h) : 0, b = W({ active: !1, startMouseX: 0, startThumbLeft: 0 }), T = W(null);
  if (N(() => {
    const v = (w) => {
      if (!b.current.active) return;
      const L = u.getState(), { containerWidth: x, setScrollPosition: C } = L, E = zt(L), k = oe(L), A = jt(L), P = ct(L), O = lt(L), B = Math.max(0, x - Gn), F = A > 0 ? E / A : 1, H = Math.max(vn, B * F), Q = Math.max(P, at(O, E, k)) - P, ie = w.clientX - b.current.startMouseX, U = B - H;
      if (U <= 0 || Q <= 0) return;
      const we = Math.max(0, Math.min(b.current.startThumbLeft + ie, U)) / U;
      C(P + we * Q);
    }, M = () => {
      b.current.active && (b.current.active = !1, document.removeEventListener("mousemove", v), document.removeEventListener("mouseup", M));
    };
    T.current = { onMouseMove: v, onMouseUp: M };
  }, [u]), i >= t) return null;
  function S(v) {
    if (v.button !== 0) return;
    v.stopPropagation();
    const M = T.current;
    M && (b.current = {
      active: !0,
      startMouseX: v.clientX,
      startThumbLeft: y
    }, document.addEventListener("mousemove", M.onMouseMove), document.addEventListener("mouseup", M.onMouseUp));
  }
  function g(v) {
    const M = l.current;
    if (!M) return;
    const w = M.getBoundingClientRect(), L = v.clientX - w.left, x = f - h;
    if (x <= 0 || m <= 0) return;
    const E = Math.max(0, Math.min(L - h / 2, x)) / x;
    d(n + E * m);
  }
  return /* @__PURE__ */ s(
    "div",
    {
      ref: l,
      className: "timeline-scrollbar",
      style: {
        position: "relative",
        flex: 1,
        minWidth: 0,
        height: 6,
        margin: "auto 4px auto 0",
        background: _,
        borderRadius: 3,
        cursor: "pointer"
      },
      onMouseDown: g,
      children: /* @__PURE__ */ s(
        "div",
        {
          style: {
            position: "absolute",
            top: 0,
            height: "100%",
            borderRadius: 3,
            background: Ze,
            cursor: "grab",
            transition: "background 0.15s",
            width: h,
            left: y
          },
          onMouseDown: S
        }
      )
    }
  );
}
const _e = 4, Yn = 1, Uc = 2, Jc = 0.7;
function el(e, t, n) {
  const r = Math.max(0, Math.floor(e / _e));
  if (r === 0 || n <= 0)
    return { firstBar: 0, lastBar: -1, numBars: r };
  const o = Math.max(0, Math.floor(t / _e)), i = Math.min(r - 1, Math.ceil((t + n) / _e));
  return { firstBar: o, lastBar: i, numBars: r };
}
function tl(e, t, n) {
  const { sourceWidthPx: r, offsetPx: o, regionWidthPx: i, regionHeightPx: c, backgroundColor: d, barColor: u } = n;
  if (e.fillStyle = d, e.fillRect(0, 0, i, c), !t || t.length === 0) return;
  const { firstBar: l, lastBar: f, numBars: a } = el(r, o, i);
  if (l > f) return;
  const h = c / 2, p = c * Jc, m = t.length;
  let y = 0;
  for (const b of t)
    Number.isFinite(b) && (y = Math.max(y, b));
  e.strokeStyle = u, e.lineWidth = Yn, e.lineCap = "round";
  for (let b = l; b <= f; b++) {
    const T = Math.min(m - 1, Math.floor(b / a * m)), S = t[T] ?? 0, g = y > 0 && Number.isFinite(S) ? S / y : 0, v = Math.max(Uc, g * p), M = b * _e - o + (_e - Yn) / 2, w = h - v / 2;
    e.beginPath(), e.moveTo(M, w), e.lineTo(M, w + v), e.stroke();
  }
}
function Bt({
  peaks: e,
  sourceWidthPx: t,
  offsetPx: n,
  width: r,
  height: o,
  borderRadius: i,
  inset: c = 1
}) {
  const d = W(null);
  return N(() => {
    const u = d.current;
    if (!u) return;
    const l = window.devicePixelRatio || 1;
    u.width = Math.max(1, Math.round(r * l)), u.height = Math.max(1, Math.round(o * l));
    const f = u.getContext("2d");
    f && (f.setTransform(l, 0, 0, l, 0, 0), tl(f, e, {
      sourceWidthPx: t,
      offsetPx: n,
      regionWidthPx: r,
      regionHeightPx: o,
      backgroundColor: wr,
      barColor: pi
    }));
  }, [e, t, n, r, o]), /* @__PURE__ */ s(
    "canvas",
    {
      ref: d,
      style: {
        position: "absolute",
        inset: c,
        width: `calc(100% - ${c * 2}px)`,
        height: `calc(100% - ${c * 2}px)`,
        pointerEvents: "none",
        borderRadius: i
      }
    }
  );
}
function nl(e, t) {
  switch (t) {
    case "ease-in":
      return e * e;
    case "ease-out":
      return 1 - (1 - e) ** 2;
    case "ease-in-out":
      return e < 0.5 ? 2 * e * e : 1 - (-2 * e + 2) ** 2 / 2;
    default:
      return e;
  }
}
function rl(e, t) {
  return `M 0 0 H 100 ${Array.from({ length: 27 }, (r, o) => {
    const i = 1 - o / 26, c = nl(i, t);
    return `L ${i * 100} ${(e === "in" ? 1 - c : c) * 100}`;
  }).join(" ")} Z`;
}
function ol(e, t, n, r) {
  let o = e, i = 10 / r;
  for (const c of t) {
    if (c < 0 || c > n) continue;
    const d = Math.abs(c - e);
    d <= i && (o = c, i = d);
  }
  return Math.max(0, Math.min(n, Math.round(o * 100) / 100));
}
function il(e, t) {
  var T, S;
  const { store: n, onTrackSelect: r, onTrackFadeDurationChange: o, onTrackFadeDurationCancel: i } = G(), c = I(oe), [d, u] = V(null), l = W(null), f = W(i);
  f.current = i, N(
    () => () => {
      var g, v;
      (g = l.current) != null && g.changed && ((v = f.current) == null || v.call(f)), l.current = null;
    },
    []
  );
  const a = R(() => {
    if (!l.current) return;
    const { changed: g, target: v, pointerId: M } = l.current;
    l.current = null, g && (i == null || i()), v.hasPointerCapture(M) && v.releasePointerCapture(M), u(null);
  }, [i]), h = R(
    (g, v, M) => {
      const w = l.current;
      if (!w) return;
      w.clientX = g;
      const L = n.getState(), x = (g - w.x) / w.pixelsPerSecond + L.scrollPosition - w.scrollPosition;
      if (!w.changed && Math.abs(x * w.pixelsPerSecond) < 2) return;
      const C = v ? e.duration / 2 : e.duration, E = w.fade.duration + (t === "in" ? x : -x), k = M ? [
        L.currentTime - e.startTime,
        e.startTime + e.duration - L.currentTime,
        ...L.tracks.flatMap(
          (P) => ["in", "out"].flatMap((O) => {
            var F;
            if (P.id === e.id && (O === t || v)) return [];
            const B = (F = P.opacityFade) == null ? void 0 : F[O];
            return B ? [B.duration] : [];
          })
        )
      ] : [], A = ol(E, k, C, w.pixelsPerSecond);
      A === w.duration && v === w.mirror && w.changed || (w.changed = !0, w.duration = A, w.mirror = v, u(A), o == null || o(e.id, t, A, !0, v));
    },
    [n, e.id, e.duration, e.startTime, t, o]
  );
  N(() => {
    const g = (v) => {
      const M = l.current;
      M && (v.key === "Escape" && v.type === "keydown" ? (v.preventDefault(), v.stopPropagation(), a()) : v.key === "Alt" && (v.preventDefault(), h(M.clientX, v.altKey, v.shiftKey)));
    };
    return document.addEventListener("keydown", g), document.addEventListener("keyup", g), () => {
      document.removeEventListener("keydown", g), document.removeEventListener("keyup", g);
    };
  }, [a, h]);
  const p = ((T = e.opacityFade) == null ? void 0 : T[t]) ?? ((S = l.current) == null ? void 0 : S.fade), m = d ?? (p == null ? void 0 : p.duration) ?? 0, y = de(e) || !o || !i;
  return { fade: p, duration: m, locked: y, pixelsPerSecond: c, dragging: d !== null, handleProps: {
    onMouseDown: (g) => g.stopPropagation(),
    onMouseMove: (g) => g.stopPropagation(),
    onDoubleClick: (g) => g.stopPropagation(),
    onPointerDown: (g) => {
      var v;
      g.button !== 0 || l.current || !(p != null && p.enabled) || (g.stopPropagation(), g.preventDefault(), r(e.id), !y && ((v = g.currentTarget.closest(".timeline-track-clip")) == null || v.focus({ preventScroll: !0 }), g.currentTarget.setPointerCapture(g.pointerId), l.current = {
        pointerId: g.pointerId,
        target: g.currentTarget,
        x: g.clientX,
        clientX: g.clientX,
        fade: p,
        scrollPosition: n.getState().scrollPosition,
        pixelsPerSecond: c,
        duration: m,
        mirror: !1,
        changed: !1
      }));
    },
    onPointerMove: (g) => {
      var v;
      ((v = l.current) == null ? void 0 : v.pointerId) === g.pointerId && h(g.clientX, g.altKey, g.shiftKey);
    },
    onPointerUp: (g) => {
      const v = l.current;
      !v || v.pointerId !== g.pointerId || (v.changed && h(v.clientX, g.altKey, g.shiftKey), l.current = null, v.changed && (o == null || o(e.id, t, v.duration, !1, v.mirror)), u(null));
    },
    onPointerCancel: a,
    onLostPointerCapture: a
  } };
}
function qn({ track: e, edge: t, width: n, offset: r, visibleWidth: o }) {
  const { fade: i, duration: c, locked: d, pixelsPerSecond: u, dragging: l, handleProps: f } = il(e, t);
  if (!(i != null && i.enabled)) return null;
  const a = c * u, h = `Fade ${t} duration`, p = -r + (t === "in" ? 0 : n - a), m = p + (t === "in" ? a : 0);
  return /* @__PURE__ */ D(
    "div",
    {
      className: `timeline-clip-fade${l ? " dragging" : ""}`,
      style: { position: "absolute", inset: 0, borderRadius: "inherit", pointerEvents: "none", outline: "none" },
      children: [
        /* @__PURE__ */ D(
          "div",
          {
            style: { position: "absolute", inset: 0, borderRadius: "inherit", overflow: "hidden", pointerEvents: "none" },
            children: [
              /* @__PURE__ */ s(
                "svg",
                {
                  style: {
                    position: "absolute",
                    top: 0,
                    left: p,
                    width: a,
                    height: "100%",
                    fill: "rgba(30, 30, 30, 0.54)",
                    pointerEvents: "none"
                  },
                  viewBox: "0 0 100 100",
                  preserveAspectRatio: "none",
                  "aria-hidden": "true",
                  children: /* @__PURE__ */ s("path", { d: rl(t, i.easing) })
                }
              ),
              /* @__PURE__ */ s(
                "span",
                {
                  className: "timeline-clip-fade-boundary",
                  style: {
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left: m,
                    borderLeft: "1px dashed var(--White100)"
                  }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ s(
          "div",
          {
            "aria-hidden": "true",
            "data-testid": `timeline-fade-${e.id}-${t}`,
            "data-disabled": d,
            title: `${h} · Shift to snap · Alt to mirror`,
            className: "timeline-clip-fade-handle",
            style: {
              position: "absolute",
              top: 0,
              zIndex: 2,
              width: 16,
              height: 16,
              transform: "translate(-50%, -50%)",
              cursor: "ew-resize",
              touchAction: "none",
              outline: "none",
              left: m,
              visibility: m < 0 || m > o ? "hidden" : void 0
            },
            ...f,
            children: /* @__PURE__ */ s(
              "span",
              {
                "aria-hidden": "true",
                style: {
                  position: "absolute",
                  inset: 4,
                  border: "1px solid var(--Black92)",
                  borderRadius: 2,
                  background: "var(--White100)",
                  pointerEvents: "none"
                }
              }
            )
          }
        )
      ]
    }
  );
}
const Qn = 1 - Ht;
function al(e) {
  return e.type === "video" ? { background: fi } : e.type === "audio" ? { background: wr } : e.type === "text" ? { background: di } : e.type === "shape" ? { background: e.color ?? mi } : e.type === "group" ? { background: hi } : e.thumbnailUrl === void 0 ? { background: "transparent" } : {
    background: `url("${e.thumbnailUrl}")`,
    backgroundSize: "32px 32px",
    backgroundRepeat: "repeat"
  };
}
function Wt(e, t) {
  const n = t.getBoundingClientRect();
  return e - n.left < gn ? "trim-left" : n.right - e < gn ? "trim-right" : "move";
}
function cl({ track: e, isSelected: t }) {
  const n = I((z) => z.scrollPosition), r = I((z) => z.containerWidth), o = I(oe), i = I((z) => z.setTrackTrim), c = qr(), { store: d, onTrackStartTimeChange: u, onTrackTrimChange: l, onTrackSelect: f, onTrackRightClick: a, selectedTrackIds: h } = G(), p = te() ? ft : fe, m = W({
    active: !1,
    // oxlint-disable-next-line typescript/no-unnecessary-type-assertion
    mode: "move",
    // oxlint-disable-next-line typescript/no-unnecessary-type-assertion
    primaryTrackId: -1,
    trackIds: [],
    // oxlint-disable-next-line typescript/no-unnecessary-type-assertion -- Required for numeric indexing of initialValues.
    initialValues: {},
    mouseDownClientX: 0,
    lastDelta: 0
  }), y = R(
    (z) => {
      if (z.button !== 0) return;
      z.stopPropagation(), document.activeElement instanceof HTMLElement && document.activeElement.blur();
      const ae = z.ctrlKey || z.metaKey;
      if (ae) {
        if (h.includes(e.id)) {
          f(e.id, { additive: !0 });
          return;
        }
        f(e.id, { additive: !0 });
      } else h.includes(e.id) || f(e.id);
      if (de(e)) return;
      const pe = z.currentTarget, me = Wt(z.clientX, pe);
      let se;
      ae ? se = h.includes(e.id) ? h : [...h, e.id] : se = h.includes(e.id) ? h : [e.id];
      const Pe = d.getState().tracks, ht = Mr(se, Pe).filter((ue) => {
        const Y = Pe.find((ne) => ne.id === ue);
        return Y && !de(Y);
      }), un = {};
      for (const ue of ht) {
        const Y = Pe.find((ne) => ne.id === ue);
        Y && (un[ue] = {
          startTime: Y.startTime,
          duration: Y.duration,
          trimStart: Y.trimStart ?? 0,
          trimEnd: Y.trimEnd ?? 0,
          type: Y.type
        });
      }
      m.current = {
        active: !0,
        mode: me,
        primaryTrackId: e.id,
        trackIds: ht,
        initialValues: un,
        mouseDownClientX: z.clientX,
        lastDelta: 0
      };
      const { setDraggingTrackIds: Ur } = d.getState();
      Ur(ht), me === "move" ? document.body.classList.add("timeline-dragging") : document.body.classList.add("timeline-trimming");
      const dn = (ue) => {
        if (!m.current.active) return;
        const Y = d.getState(), { frameRate: ne, setTrackStartTime: gt, setTrackTrim: pn, setSnapIndicatorTime: vt } = Y, bt = oe(Y), Jr = ue.clientX - m.current.mouseDownClientX, yt = bt > 0 ? Jr / bt : 0, wt = (ue.shiftKey ? ur : sr) / bt, { tracks: eo, currentTime: to, duration: no } = Y, xt = Qr(eo, m.current.trackIds, ne, [
          to,
          0,
          no
        ]), J = m.current.initialValues[m.current.primaryTrackId], { mode: St } = m.current;
        if (St === "move") {
          const ke = J.startTime + yt, q = Ec(ke, J.duration, xt, wt, ne), xe = q.startTime - J.startTime;
          if (vt(q.snapIndicator), xe === m.current.lastDelta) return;
          m.current.lastDelta = xe;
          for (const [ee, ze] of Object.entries(m.current.initialValues))
            gt(Number(ee), ze.startTime + xe);
          u(m.current.trackIds, xe, !0);
        } else if (St === "trim-right") {
          const ke = Ic(
            yt,
            J.duration,
            J.type,
            J.startTime,
            J.trimEnd,
            xt,
            wt,
            ne
          ), q = ke.duration - J.duration;
          if (vt(ke.snapIndicator), q === m.current.lastDelta) return;
          m.current.lastDelta = q;
          for (const [xe, ee] of Object.entries(m.current.initialValues)) {
            const ze = Number(xe), Lt = Math.max(ee.duration + q, 1 / ne), je = {
              startTime: ee.startTime,
              duration: Lt
            };
            X(ee.type) && (je.trimStart = ee.trimStart, je.trimEnd = Math.max(ee.trimEnd - q, 0)), pn(ze, je);
          }
          l(m.current.trackIds, q, "right", !0);
        } else if (St === "trim-left") {
          const ke = Pc(
            yt,
            J.duration,
            J.type,
            J.startTime,
            J.trimStart,
            xt,
            wt,
            ne
          ), q = ke.startTime - J.startTime;
          if (vt(ke.snapIndicator), q === m.current.lastDelta) return;
          m.current.lastDelta = q;
          for (const [xe, ee] of Object.entries(m.current.initialValues)) {
            const ze = Number(xe), Lt = ee.startTime + q, je = Math.max(ee.duration - q, 1 / ne), Ct = {
              startTime: Lt,
              duration: je
            };
            X(ee.type) && (Ct.trimStart = Math.max(ee.trimStart + q, 0), Ct.trimEnd = ee.trimEnd), pn(ze, Ct);
          }
          l(m.current.trackIds, q, "left", !0);
        }
      }, fn = () => {
        if (!m.current.active) return;
        const { mode: ue } = m.current;
        m.current.active = !1, document.body.classList.remove("timeline-dragging"), document.body.classList.remove("timeline-trimming");
        const { setSnapIndicatorTime: Y, setDraggingTrackIds: ne } = d.getState();
        if (Y(null), ne(null), ue === "move")
          u(m.current.trackIds, m.current.lastDelta, !1);
        else {
          const gt = ue === "trim-right" ? "right" : "left";
          l(m.current.trackIds, m.current.lastDelta, gt, !1);
        }
        document.removeEventListener("mousemove", dn), document.removeEventListener("mouseup", fn);
      };
      document.addEventListener("mousemove", dn), document.addEventListener("mouseup", fn);
    },
    [e, h, f, u, l, d]
  ), b = R(
    (z) => {
      if (de(e)) return;
      const ae = z.currentTarget, pe = Wt(z.clientX, ae), me = e.trimStart ?? 0, se = e.trimEnd ?? 0;
      if (pe === "trim-left" && me > 0) {
        const Pe = {
          startTime: e.startTime - me,
          duration: e.duration + me,
          trimStart: 0,
          trimEnd: se
        };
        i(e.id, Pe), l([e.id], -me, "left", !1);
      } else if (pe === "trim-right" && se > 0) {
        const Pe = {
          startTime: e.startTime,
          duration: e.duration + se,
          trimStart: me,
          trimEnd: 0
        };
        i(e.id, Pe), l([e.id], se, "right", !1);
      }
    },
    [e, i, l]
  ), T = de(e), S = R(
    (z) => {
      if (T || m.current.active) return;
      const ae = z.currentTarget, pe = Wt(z.clientX, ae);
      ae.style.cursor = pe === "move" ? "grab" : "ew-resize";
    },
    [T]
  ), g = R(
    (z) => {
      if (m.current.active) return;
      const ae = z.currentTarget;
      ae.style.cursor = T ? "not-allowed" : "grab";
    },
    [T]
  ), v = Z, M = r + Z, w = (e.startTime - n) * o + Z, L = w + e.duration * o, x = Math.max(v, w), C = Math.max(0, Math.min(L, M) - x), E = al(e), k = x - w, A = e.trimStart ?? 0, P = e.trimEnd ?? 0, O = A * o, B = w - O, F = L, H = P * o, le = w - O, Q = (e.duration + A + P) * o, ie = e.type === "audio" ? e.waveformPeaks : void 0, U = e.type === "audio", Ee = Math.max(v, B), we = Math.max(0, Math.min(B + O, M) - Ee), Ie = Math.max(v, F), We = Math.max(0, Math.min(F + H, M) - Ie), { active: Ue, startX: He, endX: Je, fullWidth: et } = c;
  return /* @__PURE__ */ D(
    "div",
    {
      onContextMenu: () => a == null ? void 0 : a(e.id),
      style: {
        position: "relative",
        height: Jt,
        background: "transparent",
        borderBottom: `1px solid ${_}`,
        boxSizing: "border-box"
      },
      children: [
        A > 0 && /* @__PURE__ */ s(
          "div",
          {
            style: {
              position: "absolute",
              height: Re,
              top: "50%",
              transform: "translateY(-50%)",
              borderRadius: `${De}px 0 0 ${De}px`,
              overflow: "hidden",
              pointerEvents: "none",
              left: Ee,
              width: we + De,
              background: E.background,
              backgroundSize: E.backgroundSize,
              backgroundRepeat: E.backgroundRepeat,
              opacity: Ht
            },
            children: U && /* @__PURE__ */ s(
              Bt,
              {
                peaks: ie,
                sourceWidthPx: Q,
                offsetPx: Ee - le,
                width: we,
                height: Re
              }
            )
          }
        ),
        e.duration > 0 && /* @__PURE__ */ D(
          "div",
          {
            className: `timeline-track-clip${t ? " selected" : ""}`,
            tabIndex: -1,
            style: {
              position: "absolute",
              height: Re,
              top: "50%",
              transform: "translateY(-50%)",
              borderRadius: De,
              cursor: T ? "not-allowed" : "grab",
              left: x,
              width: C,
              background: E.background,
              backgroundSize: E.backgroundSize,
              backgroundRepeat: E.backgroundRepeat,
              backgroundPosition: k > 0 ? `${-k}px 0` : void 0,
              opacity: e.hidden || e.type === "audio" && e.muted ? 0.5 : void 0
            },
            onMouseDown: y,
            onDoubleClick: b,
            onMouseMove: S,
            onMouseLeave: g,
            children: [
              /* @__PURE__ */ D(
                "div",
                {
                  style: {
                    position: "absolute",
                    inset: 0,
                    borderRadius: "inherit",
                    overflow: "hidden",
                    pointerEvents: "none"
                  },
                  children: [
                    U && /* @__PURE__ */ s(
                      Bt,
                      {
                        peaks: ie,
                        sourceWidthPx: Q,
                        offsetPx: x - le,
                        width: C,
                        height: Re
                      }
                    ),
                    e.label && /* @__PURE__ */ s(
                      re,
                      {
                        component: "span",
                        style: {
                          height: "100%",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          pointerEvents: "none",
                          userSelect: "none",
                          ...e.type === "text" ? { alignItems: "flex-start", padding: "4px 8px 0", color: si } : { padding: "0 6px", color: gi },
                          ...k > 0 ? { marginLeft: -k } : void 0
                        },
                        children: e.type === "text" && /* @__PURE__ */ s(Gi, { text: e.label })
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ s(
                qn,
                {
                  track: e,
                  edge: "in",
                  width: e.duration * o,
                  offset: k,
                  visibleWidth: C
                }
              ),
              /* @__PURE__ */ s(
                qn,
                {
                  track: e,
                  edge: "out",
                  width: e.duration * o,
                  offset: k,
                  visibleWidth: C
                }
              )
            ]
          }
        ),
        P > 0 && /* @__PURE__ */ s(
          "div",
          {
            style: {
              position: "absolute",
              height: Re,
              top: "50%",
              transform: "translateY(-50%)",
              borderRadius: `0 ${De}px ${De}px 0`,
              overflow: "hidden",
              pointerEvents: "none",
              left: Ie - De,
              width: We,
              background: E.background,
              backgroundSize: E.backgroundSize,
              backgroundRepeat: E.backgroundRepeat,
              opacity: Ht
            },
            children: U && /* @__PURE__ */ s(
              Bt,
              {
                peaks: ie,
                sourceWidthPx: Q,
                offsetPx: Ie - le,
                width: We,
                height: Re
              }
            )
          }
        ),
        Ue && He > 0 && /* @__PURE__ */ s(
          "div",
          {
            style: {
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              width: He,
              background: p,
              opacity: Qn,
              pointerEvents: "none"
            }
          }
        ),
        Ue && et - Je > 0 && /* @__PURE__ */ s(
          "div",
          {
            style: {
              position: "absolute",
              top: 0,
              bottom: 0,
              left: Je,
              width: et - Je,
              background: p,
              opacity: Qn,
              pointerEvents: "none"
            }
          }
        )
      ]
    }
  );
}
function ll() {
  const e = I((i) => i.snapIndicatorTime), t = I((i) => i.scrollPosition), n = I(oe), r = I((i) => i.containerWidth);
  if (e === null) return null;
  const o = (e - t) * n + Z;
  return o < Z - 1 || o > r + Z + 1 ? null : /* @__PURE__ */ s(
    "div",
    {
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        width: 0,
        bottom: 0,
        pointerEvents: "none",
        zIndex: 9,
        transform: `translateX(${o}px)`
      },
      children: /* @__PURE__ */ s(
        "div",
        {
          style: {
            position: "absolute",
            top: Le,
            left: 0,
            width: 1,
            bottom: 0,
            background: K
          }
        }
      )
    }
  );
}
const sl = 15, Un = Le - sl;
function ul() {
  const e = I((c) => c.currentTime), t = I((c) => c.scrollPosition), n = I(oe), r = (e - t) * n + Z, o = I((c) => c.duration), i = I((c) => c.containerWidth);
  return o === 0 || r < Z - 10 || r > i + Z + 10 ? null : /* @__PURE__ */ D(
    "div",
    {
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        width: 0,
        bottom: 0,
        pointerEvents: "none",
        zIndex: 10,
        transform: `translateX(${r}px)`
      },
      children: [
        /* @__PURE__ */ s(
          "div",
          {
            style: {
              position: "absolute",
              top: Un,
              left: -6,
              width: 12,
              height: 8,
              borderLeft: "6px solid transparent",
              borderRight: "6px solid transparent",
              borderTop: `8px solid ${K}`,
              pointerEvents: "auto"
            }
          }
        ),
        /* @__PURE__ */ s(
          "div",
          {
            style: {
              position: "absolute",
              top: Un,
              left: -1,
              width: 1,
              bottom: 0,
              background: K
            }
          }
        )
      ]
    }
  );
}
function dl() {
  const e = I(jt), t = I((f) => f.frameRate), n = I((f) => f.scrollPosition), r = I((f) => f.containerWidth), o = I(zt), i = I(oe), c = te() ? ft : fe, { ticks: d, majorInterval: u } = ot(() => {
    if (e === 0 || r === 0) return { ticks: [], majorInterval: 0 };
    const { start: f, end: a } = So(n, o, e), { interval: h, majorInterval: p } = Mo(i, t);
    return {
      ticks: Eo(f, a, h, p, t),
      majorInterval: p
    };
  }, [e, t, n, o, i, r]);
  if (e === 0)
    return /* @__PURE__ */ s("div", { style: { display: "block", borderBottom: `1px solid ${_}`, height: Le }, children: /* @__PURE__ */ s(be, { component: "span", style: { height: "100%" }, children: /* @__PURE__ */ s(Xi, { text: "No timeline data" }) }) });
  const l = r + 2 * Z;
  return /* @__PURE__ */ D("svg", { width: l, height: Le, style: { display: "block", borderBottom: `1px solid ${_}` }, children: [
    /* @__PURE__ */ s("rect", { x: 0, y: 0, width: l, height: Le, fill: c }),
    d.map((f, a) => {
      const h = (f.time - n) * i + Z;
      if (f.isMajor)
        return f.label ? /* @__PURE__ */ s(
          "text",
          {
            x: h,
            y: Le / 2 - 2,
            fill: Ze,
            fontSize: "0.75rem",
            dominantBaseline: "central",
            children: f.label
          },
          `${f.time}-${a}`
        ) : null;
      const p = Math.round(f.time / u) * u;
      if (Math.abs(f.time - p) * i < ko) return null;
      const y = Le - 12;
      return /* @__PURE__ */ s("rect", { x: h, y, width: 1, height: 2, fill: Ze }, `${f.time}-${a}`);
    })
  ] });
}
const Ke = "timeline-sidebar";
function fl(e, t, n) {
  const r = t.height > 0 ? (e - t.top) / t.height : 0.5;
  let o;
  return n.allowNesting ? o = r < 1 / 3 ? "above" : r > 2 / 3 ? "below" : "inside" : o = r < 0.5 ? "above" : "below", o === "inside" ? { mode: o, dropParentId: n.trackId, dropIndex: n.childCount } : o === "above" ? { mode: o, dropParentId: n.parentId, dropIndex: n.siblingIndex + 1 } : { mode: o, dropParentId: n.parentId, dropIndex: n.siblingIndex };
}
function pl({ meta: e, children: t }) {
  const n = W(null), [r, o] = V(), { trackId: i, parentId: c, siblingIndex: d, childCount: u, allowNesting: l } = e;
  return N(() => {
    const f = n.current;
    if (!f) return;
    const a = { trackId: i, parentId: c, siblingIndex: d, childCount: u, allowNesting: l }, h = Qa({
      element: f,
      getInitialData: () => ({ type: Ke, trackId: i })
    }), p = qa({
      element: f,
      canDrop: ({ source: m }) => m.data.type === Ke && m.data.trackId !== i,
      getData: ({ input: m }) => {
        const { mode: y, dropParentId: b, dropIndex: T } = fl(m.clientY, f.getBoundingClientRect(), a);
        return { type: Ke, trackId: i, mode: y, dropParentId: b, dropIndex: T };
      },
      onDrag: ({ self: m }) => o(m.data.mode),
      onDragLeave: () => o(void 0),
      onDrop: () => o(void 0)
    });
    return () => {
      h(), p();
    };
  }, [i, c, d, u, l]), /* @__PURE__ */ D("div", { ref: n, style: { position: "relative" }, children: [
    (r === "above" || r === "below") && /* @__PURE__ */ s(
      "div",
      {
        style: {
          position: "absolute",
          left: 0,
          right: 0,
          [r === "above" ? "top" : "bottom"]: 0,
          height: 2,
          background: Fe,
          zIndex: 1,
          pointerEvents: "none"
        }
      }
    ),
    /* @__PURE__ */ s(
      "div",
      {
        style: {
          outline: r === "inside" ? `1px solid ${Fe}` : "none",
          outlineOffset: "-1px"
        },
        children: t
      }
    )
  ] });
}
const ml = {
  text: ji,
  image: Dc,
  video: Oc,
  audio: Or,
  shape: Fc,
  group: Wc
}, hl = 16, Zt = 16;
function gl({
  collapsed: e,
  onToggle: t,
  iconColor: n
}) {
  return /* @__PURE__ */ s(
    re,
    {
      onMouseDown: (r) => {
        r.stopPropagation();
      },
      onClick: (r) => {
        r.stopPropagation(), t();
      },
      style: {
        width: Zt,
        height: Zt,
        flexShrink: 0,
        justifyContent: "center",
        cursor: "pointer",
        color: n
      },
      children: /* @__PURE__ */ s(
        rn,
        {
          style: {
            width: 12,
            height: 12,
            transform: e ? "rotate(-90deg)" : "none",
            transition: "transform 0.1s ease-in-out"
          }
        }
      )
    }
  );
}
function vl({ track: e }) {
  const { onTrackSelect: t, onTrackRightClick: n, onTrackRename: r, onTrackToggleCollapse: o, selectedTrackIds: i } = G(), c = I((v) => v.tracks.some((M) => (M.childCount ?? 0) > 0)), d = ml[e.type], [u, l] = V(!1), [f, a] = V(!1), h = te(), p = R(
    (v) => {
      r == null || r(e.id, v);
    },
    [r, e.id]
  ), m = (e.childCount ?? 0) > 0, y = i.includes(e.id), b = h ? K : Xe, T = h ? xr : Ze, S = e.hidden ? T : b, g = h ? y ? yi : f ? bi : "transparent" : "transparent";
  return /* @__PURE__ */ D(
    re,
    {
      style: {
        height: Jt,
        justifyContent: "space-between",
        cursor: "pointer",
        padding: h ? "0 16px" : "0 8px",
        paddingLeft: c ? (h ? 16 : 8) + (e.depth ?? 0) * hl : h ? 16 : 8,
        position: "relative",
        color: S,
        borderBottom: `1px solid ${_}`,
        boxSizing: "border-box"
      },
      onMouseEnter: () => a(!0),
      onMouseLeave: () => a(!1),
      onMouseDown: (v) => {
        v.button === 0 && (v.stopPropagation(), document.activeElement instanceof HTMLElement && document.activeElement.blur(), t(e.id, { additive: v.ctrlKey || v.metaKey }));
      },
      onContextMenu: () => n == null ? void 0 : n(e.id),
      children: [
        h && /* @__PURE__ */ s(
          "div",
          {
            "aria-hidden": "true",
            style: {
              background: g,
              borderRadius: 5,
              inset: "4px 8px",
              pointerEvents: "none",
              position: "absolute",
              zIndex: 0
            }
          }
        ),
        /* @__PURE__ */ D(re, { style: { gap: "4px", flex: 1, minWidth: 0, position: "relative", zIndex: 1 }, children: [
          c && (m && o ? /* @__PURE__ */ s(
            gl,
            {
              collapsed: e.collapsed ?? !1,
              onToggle: () => o(e.id),
              iconColor: S
            }
          ) : /* @__PURE__ */ s("div", { style: { width: Zt, flexShrink: 0 } })),
          /* @__PURE__ */ s(d, { style: { flexShrink: 0 }, width: 16, height: 16, color: S }),
          /* @__PURE__ */ s(
            re,
            {
              style: {
                flex: 1,
                minWidth: 0,
                overflow: "visible",
                textOverflow: "ellipsis",
                color: S
              },
              children: /* @__PURE__ */ s(
                Gc,
                {
                  "data-testid": `timeline-track-name-${e.id}`,
                  value: e.name,
                  onSubmit: p,
                  onEditingChange: l,
                  readOnly: de(e),
                  maxWidth: "100%",
                  style: { color: S }
                }
              )
            }
          )
        ] }),
        !u && /* @__PURE__ */ D(Oe, { style: { gap: "2px", position: "relative", zIndex: 1 }, children: [
          /* @__PURE__ */ s(bl, { track: e }),
          /* @__PURE__ */ s(yl, { track: e }),
          /* @__PURE__ */ s(wl, { track: e })
        ] })
      ]
    }
  );
}
function bl({ track: e }) {
  const { onTrackMuteToggle: t } = G();
  if (e.type !== "video" && e.type !== "audio") return null;
  const n = e.muted ?? !1;
  return /* @__PURE__ */ s(
    Rr,
    {
      onToggle: () => t(e.id, !n),
      muted: n,
      size: "medium",
      disabled: de(e)
    }
  );
}
function yl({ track: e }) {
  const { onTrackVisibilityToggle: t } = G();
  if (e.type === "audio") return null;
  const n = e.hidden;
  return /* @__PURE__ */ s(
    Nc,
    {
      onToggle: () => t(e.id, !n),
      hidden: n,
      disabled: de(e)
    }
  );
}
function wl({ track: e }) {
  const { onTrackLockToggle: t } = G();
  return /* @__PURE__ */ s(
    Zc,
    {
      onToggle: () => t(e.id, !e.locked),
      locked: de(e),
      disabled: e.lockedByAncestor ?? !1
    }
  );
}
function kl() {
  const e = W(null), t = W(null), n = W(null), r = I((w) => w.duration), o = I((w) => w.setContainerWidth), i = I((w) => w.tracks), { store: c, onSeek: d, onTrackSelect: u, onTrackReorder: l, selectedTrackIds: f, allowNesting: a } = G(), h = te(), p = h ? ft : fe, m = h ? vi : yr;
  Cc(e), Tc(e), N(() => {
    const w = e.current;
    if (!w) return;
    const L = () => {
      o(Math.max(0, w.clientWidth - 2 * Z));
    };
    L();
    const x = new ResizeObserver(L);
    return x.observe(w), () => x.disconnect();
  }, [o]), Mc(t, n), N(() => $r({
    canMonitor: ({ source: w }) => w.data.type === Ke,
    onDrop: ({ source: w, location: L }) => {
      const x = L.current.dropTargets[0];
      if (!x) return;
      const C = w.data.trackId, E = x.data.dropIndex, k = x.data.dropParentId;
      if (typeof C != "number" || typeof E != "number") return;
      l(C, typeof k == "number" ? k : null, E);
    }
  }), [l]), N(() => {
    const w = n.current;
    if (w)
      return Lc({
        element: w,
        canScroll: ({ source: L }) => L.data.type === Ke
      });
  }, []);
  const y = W({
    active: !1,
    wasPlaying: !1
  }), b = R(
    (w) => {
      const L = c.getState();
      if (w.button !== 0 || L.duration === 0) return;
      w.stopPropagation(), y.current.active = !0, y.current.wasPlaying = L.isPlaying, document.body.style.cursor = "ew-resize", L.isPlaying && L.setPlaying(!1);
      function x(k, A = !1) {
        const P = e.current;
        if (!P) return;
        const O = c.getState(), { scrollPosition: B, duration: F, frameRate: H, tracks: le, setCurrentTime: Q, setSnapIndicatorTime: ie } = O, U = oe(O), Ee = P.getBoundingClientRect(), we = k - Ee.left - Z, Ie = Lo(we, B, U), We = dt(F, H), Ue = Math.round(Ie * H) / H, He = Math.max(0, Math.min(Ue, We)), et = (A ? ur : sr) / U, z = Qr(le, [], H, [0, We]), { snappedEdge: ae, snapIndicator: pe } = sn(He, z, et);
        ie(pe);
        const se = Q(pe !== null ? ae : He);
        d(se);
      }
      const C = (k) => {
        y.current.active && x(k.clientX, k.shiftKey);
      }, E = () => {
        if (!y.current.active) return;
        y.current.active = !1, document.body.style.cursor = "";
        const { setSnapIndicatorTime: k, setPlaying: A } = c.getState();
        k(null), y.current.wasPlaying && A(!0), document.removeEventListener("mousemove", C), document.removeEventListener("mouseup", E);
      };
      x(w.clientX, w.shiftKey), document.addEventListener("mousemove", C), document.addEventListener("mouseup", E);
    },
    [d, c]
  ), T = R(
    (w) => {
      w.button === 0 && u(null);
    },
    [u]
  ), { active: S, startX: g, endX: v } = qr(), M = S && v > g ? `linear-gradient(to right, ${p} ${g}px, ${m} ${g}px, ${m} ${v}px, ${p} ${v}px)` : p;
  return /* @__PURE__ */ s(
    pt,
    {
      className: "timeline-container",
      style: {
        flex: 1,
        minHeight: 0,
        background: p,
        borderTop: `1px solid ${_}`,
        fontFamily: "'DM Sans', sans-serif"
      },
      onMouseDown: T,
      children: /* @__PURE__ */ D(Oe, { style: { flex: 1, minHeight: 0 }, children: [
        /* @__PURE__ */ D(
          "div",
          {
            style: {
              width: Po,
              flexShrink: 0,
              display: "flex",
              flexDirection: "column",
              background: p,
              borderRight: `1px solid ${_}`
            },
            children: [
              /* @__PURE__ */ s("div", { style: { height: Le, flexShrink: 0, borderBottom: `1px solid ${_}` } }),
              /* @__PURE__ */ s(
                "div",
                {
                  ref: n,
                  className: "timeline-sidebar-scroll",
                  style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: "auto",
                    marginTop: -4,
                    paddingTop: 4,
                    borderBottom: i != null && i.length ? "none" : `1px solid ${_}`
                  },
                  children: i.map((w) => /* @__PURE__ */ s(
                    pl,
                    {
                      meta: {
                        trackId: w.id,
                        parentId: w.parentId ?? null,
                        siblingIndex: w.siblingIndex ?? 0,
                        childCount: w.childCount ?? 0,
                        allowNesting: a
                      },
                      children: /* @__PURE__ */ s(vl, { track: w })
                    },
                    w.id
                  ))
                }
              ),
              r > 0 && /* @__PURE__ */ s("div", { style: { height: hn, flexShrink: 0 } })
            ]
          }
        ),
        /* @__PURE__ */ D(
          "div",
          {
            ref: e,
            style: {
              position: "relative",
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              cursor: "pointer",
              userSelect: "none"
            },
            onMouseDown: b,
            children: [
              /* @__PURE__ */ D(
                "div",
                {
                  style: {
                    position: "relative",
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column"
                  },
                  children: [
                    /* @__PURE__ */ s(dl, {}),
                    /* @__PURE__ */ s(
                      "div",
                      {
                        ref: t,
                        className: "timeline-tracks-scroll",
                        style: {
                          flex: 1,
                          minHeight: 0,
                          overflowY: "auto",
                          marginTop: -4,
                          paddingTop: 4,
                          background: M
                        },
                        children: /* @__PURE__ */ s("div", { style: { position: "relative" }, children: i.length === 0 ? /* @__PURE__ */ s(
                          "div",
                          {
                            style: {
                              position: "relative",
                              height: Jt,
                              background: p,
                              borderBottom: `1px solid ${_}`,
                              boxSizing: "border-box"
                            }
                          }
                        ) : i.map((w) => /* @__PURE__ */ s(cl, { track: w, isSelected: f.includes(w.id) }, w.id)) })
                      }
                    ),
                    /* @__PURE__ */ s(ll, {}),
                    /* @__PURE__ */ s(ul, {})
                  ]
                }
              ),
              r > 0 && /* @__PURE__ */ D(
                Oe,
                {
                  style: {
                    height: hn,
                    flexShrink: 0,
                    borderTop: `1px solid ${_}`,
                    padding: `0 ${fr}px`
                  },
                  children: [
                    /* @__PURE__ */ s("div", { style: { width: dr, flexShrink: 0 }, children: /* @__PURE__ */ s(Yc, {}) }),
                    /* @__PURE__ */ s(Qc, {})
                  ]
                }
              )
            ]
          }
        )
      ] })
    }
  );
}
export {
  Bt as AudioLayerBackground,
  Jt as DEFAULT_TRACK_HEIGHT,
  Ml as PLAYBACK_CONTROLS_HEIGHT,
  Pl as PlaybackControls,
  Le as RULER_HEIGHT,
  hn as SCROLLBAR_AREA_HEIGHT,
  ea as TimecodeInput,
  kl as Timeline,
  El as TimelineProvider,
  Qi as secondsToTimecodeFrame,
  Il as timecodeFrameToSeconds
};
